var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useEffect, useRef, useMemo, useContext } from "react";
import GenericTabs from "@frameworks/shared-library/components/GenericTabs";
import AllTransactions from "./AllTransactions/AllTransactions";
import "@frameworks/salesjourney/stylesheets/components/Features/ActivityBook/RM_Orderbook/ManagePortfolio/MutualFundOrders/MutualFundOrders.scss";
import GenericSchemeName from "@frameworks/shared-library/components/GenericSchemeName/GenericSchemeName";
import GenericStatus, { EGenericStatusType, } from "@frameworks/shared-library/components/GenericStatus/GenericStatus";
import { roundUpTonDecimals } from "@domains/utils/numberMethods";
import SIPOrders from "./SIPOrders/SIPOrders";
import STPOrders from "./STPOrders/STPOrders";
import SWPOrders from "./SWPOrders/SWPOrders";
import MandateOrders from "./MandateOrders/MandateOrders";
import di from "@mainDi/features/ActivityBook/OrderBook/MutualFund/servicelocator";
import moment from "moment";
import OrderBookSideBarHeader from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSideBarHeader";
import { EUserRole, } from "@domains/features/ActivityBook/OrderBook/MutualFund/entities/IGetMFOrderbookSummaryEntity";
import _ from "underscore";
import tocDi from "@frameworks/web/components/features/TOC/di/servicelocator";
import SearchPanelWithPopupFiltersLabel from "@frameworks/shared-library/components/SearchPanelWithPopupFiltersLabel/SearchPanelWithPopupFiltersLabel";
import VerticalFilterTabs from "@frameworks/shared-library/components/VerticalFilterTabs/VerticalFilterTabs";
import GenericCheckbox from "@frameworks/shared-library/components/GenericCheckbox/GenericCheckbox";
import FundSearchPanel from "@frameworks/shared-library/components/Generic/FundSeachPanel/FundSearchPanel";
import RadioButton from "@frameworks/web/components/generic/RadioButton/radioButton";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import { nanoid } from "nanoid";
import { EMandateStatuses, ETransactionType, orderBookStatusType, } from "@frameworks/shared-library/components/OrderBookSideBar/OrderBookSidebarConstants";
import MandateCalendar from "@frameworks/shared-library/components/MandateCalendar/MandateCalendar/MandateCalendar";
import diBasicProfile from "@frameworks/web/components/features/BasicProfile/di/servicelocator";
import { useSelector } from "react-redux";
import { EMutualFundOrderTabs, getTabIndex, } from "@domains/features/ActivityBook/OrderBook/MutualFund/entities/IMutualFundTransactionsCommonEntity";
import { allTransactionInitialData } from "@redux/feature/ActivityBook/OrderBook/MutualFund/Reducers/MutualFundAllTransactionsReducers";
import { SIP_STP_SWP_InitialData } from "@redux/feature/ActivityBook/OrderBook/MutualFund/Reducers/MutualFundSIP_STP_SWP_TransactionsReducers";
import ExcelPdfDownload from "../../common/ExcelPdfDownload/ExcelPdfDownload";
import ClientNamesWithClientCodes from "../../common/ClientNamesWithClientCodes/ClientNamesWithClientCodes";
import { Overlay, Popover, Spinner } from "react-bootstrap";
import BasicErrorMessage from "@frameworks/shared-library/components/BasicErrorMessage/BasicErrorMessage";
import { EInvestmentType, EMandateType, generateClientTierIcon, trxTypeToInvTypeMapping, } from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFundConstant";
import MutualFund from "@frameworks/shared-library/components/TransactionJourney/MutualFund/MutualFund";
import TocHoc from "@frameworks/web/components/features/TOC/TocHoc";
import { accountDetails } from "@mainDi/salesDi";
import MFOrderbookCalendarFilter from "../../common/MFOrderbookCalendarFilter/MFOrderbookCalendarFilter";
import orderbookDi from "@mainDi/features/ActivityBook/OrderBook/MutualFund/servicelocator";
import { AllKebabMenuItems, generateKebabMenuItemsForMandate, } from "@domains/utils/orderBookMutualFunds";
import MandateOrderStatusFilters from "../../common/MandateOrderFilters/MandateOrderStatusFilters/MandateOrderStatusFilters";
import MandateTypeFilters from "../../common/MandateOrderFilters/MandateTypeFilters/MandateTypeFilters";
import debounce from "@frameworks/web/utils/debounce";
import ClientNamesWithHorizontalClientCodes from "../../common/ClientNamesWithHorizontalClientCodes/ClientNamesWithHorizontalClientCodes";
import { ILoginTypeEnum } from "@domains/salesFeatures/Login/entities/iLogin";
import { isEmpty } from "@domains/utils/validation";
import { capitalizeFirstLetter } from "@frameworks/salesjourney/utils/genericMethods";
import { useNavigate } from "react-router-dom";
import { EFilterType } from "@domains/utils/filter";
import { useLocation } from "react-router-dom";
import MutualFundOrderbookContext, { EKebebMenuItems, } from "@frameworks/salesjourney/components/Features/ActivityBook/RM_Orderbook/ManagePortfolio/MutualFundOrders/MutualFundOrderbookContext";
import { leadRedirectionState, } from "../../ProductOrders";
import { EProductIds, ESubProductIds, } from "@frameworks/shared-library/components/Orderbook/common/OrderbookConstants";
import { ProductOrderContext } from "../../ProductOrders/ProductOrdersContext";
import OrderbookTransferInTable from "@frameworks/arn-transfer/components/OrderBook/OrderbookTransferInTable";
import { alphabetsColorsConfigMap } from "@frameworks/shared-library/components/TextFirstAlphabetAsIcon/colorConfigurationsForTextFirstAlphabetAsIcon";
import { ESortOrder } from "@domains/features/Markets/MutualFunds/dto/MutualFundsSchemesDTO";
import TransferInFilters from "./TransferIn/TransferInFilters";
import { checkIfARNIsAccessible } from "@frameworks/salesjourney/utils/genericMethods";
var investmentTypeFilter = [
    {
        label: "Investments",
        value: "Investment",
    },
    {
        label: "Redemption",
        value: "Redemption",
    },
    {
        label: "Switch",
        value: "Switch",
    },
];
var currentDate = new Date();
var year = currentDate.getFullYear();
var month = currentDate.toLocaleString("en-us", { month: "short" });
var firstDateOfMonth = "01 ".concat(month, " ").concat(year);
export var EDescriptiveMandateType;
(function (EDescriptiveMandateType) {
    EDescriptiveMandateType["Physical"] = "Physical";
    EDescriptiveMandateType["Digital"] = "Digital";
})(EDescriptiveMandateType || (EDescriptiveMandateType = {}));
export var EStatusTypeForTransferInTable;
(function (EStatusTypeForTransferInTable) {
    EStatusTypeForTransferInTable["IN_PROGRESS"] = "in progress";
    EStatusTypeForTransferInTable["COMPLETED"] = "completed";
    EStatusTypeForTransferInTable["EXPIRED"] = "expired";
})(EStatusTypeForTransferInTable || (EStatusTypeForTransferInTable = {}));
var tempData = [
    {
        icon: "edel-icon-page-search",
        text: EKebebMenuItems.VIEW_DETAILS,
    },
    {
        icon: "edel-icon-calendar-down-arrow",
        text: EKebebMenuItems.START_SWP,
    },
    {
        icon: "edel-icon-transfer",
        text: EKebebMenuItems.START_STP,
    },
    {
        icon: "edel-icon-coin-stack",
        text: EKebebMenuItems.START_SIP,
    },
    {
        icon: "edel-icon-money-bag",
        text: EKebebMenuItems.START_LUMPSUM,
    },
    {
        icon: "edel-icon-switch-fund-3",
        text: EKebebMenuItems.SWITCH_FUND,
    },
    {
        icon: "edel-icon-editicon-underline",
        text: EKebebMenuItems.MODIFY,
    },
    {
        icon: "edel-icon-pause",
        text: EKebebMenuItems.PAUSE,
    },
    {
        icon: "edel-icon-rounded-close",
        text: EKebebMenuItems.CANCEL,
    },
    {
        icon: "edel-icon-calendar-cross",
        text: EKebebMenuItems.CANCEL_SIP,
    },
    {
        icon: "edel-icon-calendar-search",
        text: EKebebMenuItems.VIEW_MANDATE_CALENDAR,
    },
    {
        icon: "edel-icon-rupee-download",
        text: EKebebMenuItems.REDEEM,
    },
    {
        icon: "edel-icon-copy-2",
        text: EKebebMenuItems.DUPLICATE,
    },
    {
        icon: "edel-icon-orderbook-2-refresh",
        text: EKebebMenuItems.PLACE_ORDER_AGAIN,
    },
    {
        icon: "edel-icon-database-eye",
        text: EKebebMenuItems.VIEW_ALL_SIPS,
    },
    {
        icon: "edel-icon-page-eye-with-border",
        text: EKebebMenuItems.VIEW_ALL_STPS,
    },
    {
        icon: "edel-icon-page-eye-without-border",
        text: EKebebMenuItems.VIEW_ALL_SWPS,
    },
    {
        icon: "edel-icon-reload",
        text: EKebebMenuItems.RESEND_CONSENT_REQUEST,
    },
    {
        icon: "edel-icon-reload",
        text: EKebebMenuItems.RESEND_PAYMENT_LINK,
    },
    {
        icon: "edel-icon-pause",
        text: EKebebMenuItems.RESUME,
    },
    {
        icon: "edel-icon-folded-paper",
        text: EKebebMenuItems.VIEW_TRANSACTION,
    },
];
var timeOutIdForUpdateAllTransactionsFilters = null;
var transactionTypeCodeMap = {};
var MutualFundOrders = function (props) {
    var _a, _b;
    var location = useLocation();
    var navigate = useNavigate();
    var params = new URLSearchParams(location.search);
    var selectedParams = (_a = location.state) === null || _a === void 0 ? void 0 : _a.selectedDetails;
    leadRedirectionState.orderId = params.get("orderId");
    leadRedirectionState.orderDate =
        params.get("orderdate") || params.get("orderDate");
    // *******************************************
    // *           useStates                 *
    // *******************************************
    var _c = __read(useState(undefined), 2), mandatesData = _c[0], setMandatesData = _c[1];
    // const [isInOfScheme, setIsInOfScheme] = useState<string>("");
    // const [isInOfSchemeName, setIsInOfSchemeName] = useState<string>("");
    var _d = __read(useState(""), 2), vendorId = _d[0], setVendorId = _d[1];
    var _e = __read(useState(""), 2), trxId = _e[0], setTrxId = _e[1];
    var _f = __read(useState(""), 2), mandateId = _f[0], setMandateId = _f[1];
    var _g = __read(useState(false), 2), isShowMandatesShimmer = _g[0], setIsShowMandatesShimmer = _g[1];
    var _h = __read(useState(false), 2), showMandateCalendar = _h[0], setShowMandateCalendar = _h[1];
    var _j = __read(useState(new Map()), 2), dateAmountDict = _j[0], setDateAmountDict = _j[1];
    var _k = __read(useState(false), 2), mfToc = _k[0], setMfToc = _k[1];
    var _l = __read(useState(false), 2), isModify = _l[0], setIsModify = _l[1];
    // update the below state later once you get to know where we can get the client details
    var _m = __read(useState(null), 2), clientDetailsToSidebar = _m[0], setClientDetailsToSidebar = _m[1];
    var _o = __read(useState(""), 2), schemeGroupCodeOfScheme = _o[0], setSchemeGroupCodeOfScheme = _o[1];
    // const [schemeCodeOfScheme, setSchemeCodeOfScheme] = useState("");
    var _p = __read(useState(""), 2), transactionTypeOfScheme = _p[0], setTransactionTypeOfScheme = _p[1];
    var _q = __read(useState(), 2), allTransactionsFilter = _q[0], setAllTransactionsFilter = _q[1];
    var _r = __read(useState(), 2), SIP_STP_SWP_TransactionsFilter = _r[0], setSIP_STP_SWP_TransactionsFilter = _r[1];
    // TODO: change the labels states to one
    var _s = __read(useState(undefined), 2), mandatesFilters = _s[0], setMandatesFilters = _s[1];
    // useState<ISelectedValuesList>(undefined);
    var _t = __read(useState([]), 2), allTransactionsFilterLabels = _t[0], setAllTransactionsFilterLabels = _t[1];
    var _u = __read(useState([]), 2), SIP_STP_SWP_FilterLabels = _u[0], setSIP_STP_SWP_FilterLabels = _u[1];
    var _v = __read(useState([]), 2), mandateFilterLabels = _v[0], setMandateFilterLabels = _v[1];
    var _w = __read(useState(false), 2), isShowFilterPopup = _w[0], setIsShowFilterPopup = _w[1];
    var _x = __read(useState(false), 2), excelDownloadLoader = _x[0], setExcelDownloadLoader = _x[1];
    var _y = __read(useState(false), 2), isShowExportPopup = _y[0], setIsShowExportPopup = _y[1];
    var _z = __read(useState([]), 2), localClientsList = _z[0], setLocalClientsList = _z[1];
    var _0 = __read(useState(""), 2), searchedClient = _0[0], setSearchedClient = _0[1];
    var _1 = __read(useState([]), 2), transactionType = _1[0], setTransactionType = _1[1];
    var _2 = __read(useState(false), 2), openSBViewDetails = _2[0], setOpenSBViewDetails = _2[1];
    var _3 = __read(useState(), 2), selectedRowSchemeDetails = _3[0], setSelectedRowSchemeDetails = _3[1];
    var _4 = __read(useState(), 2), selectedRowDetailsViewDetails = _4[0], setSelectedRowDetailsViewDetails = _4[1];
    var _5 = __read(useState(), 2), selectedViewDetailsTransferIn = _5[0], setSelectedViewDetailsTransferIn = _5[1];
    var _6 = __read(useState(), 2), selectedRowDetailsViewDetailsForMandates = _6[0], setSelectedRowDetailsViewDetailsForMandates = _6[1];
    var _7 = __read(useState({
        isShowPopup: false,
        containerId: "",
    }), 2), tableRowActionPopupConfig = _7[0], setTableRowActionPopupConfig = _7[1];
    var _8 = __read(useState([]), 2), tableRowThreeDotActionPopupList = _8[0], setTableRowThreeDotActionPopupList = _8[1];
    var _9 = __read(useState(false), 2), isLoadingKebabMenuFlags = _9[0], setIsLoadingKebabMenuFlags = _9[1];
    var _10 = __read(useState({ mandateId: "", isViewDetailsClicked: false }), 2), viewDetailsForMandateConfig = _10[0], setViewDetailsForMandateConfig = _10[1];
    var _11 = __read(useState({ type: ESortOrder.DESCENDING, sortKey: "ac_name" }), 2), sortType = _11[0], setSortType = _11[1];
    var productOrdersContext = useContext(ProductOrderContext);
    // *******************************************
    // *           REFS                          *
    // *******************************************
    var orderbookRef = useRef(null);
    // *******************************************
    // *           useSelectors                 *
    // *******************************************
    var profileData = useSelector(function (state) { return state.Profile.ProfileDetails.reducersData.data; });
    var currentSelectedTransactionsTab = useSelector(function (state) {
        return state.OrderbookMutualFundsTransactions.mutualFundTransactionsCommonReducer
            .currentSelectedTransactionTab;
    });
    var allTransactionsDataFromRedux = useSelector(function (state) {
        var _a;
        return (_a = state.OrderbookMutualFundsTransactions.mutualFundsAllTransactionsReducer
            .allTransactionsData) === null || _a === void 0 ? void 0 : _a.data;
    }, _.isEqual);
    var metaDataForAllTransactionsFromRedux = useSelector(function (state) {
        return state.OrderbookMutualFundsTransactions
            .mutualFundsAllTransactionsReducer;
    }, _.isEqual);
    var SIP_STP_SWP_TransactionsDataFromRedux = useSelector(function (state) {
        var _a;
        return (_a = state.OrderbookMutualFundsTransactions
            .mutualFundsSIP_STP_SWP_TransactionsReducer
            .SIP_STP_SWP_TransactionsData) === null || _a === void 0 ? void 0 : _a.data;
    }, _.isEqual);
    var metaDataForSIP_STP_SWP_TransactionsFromRedux = useSelector(function (state) {
        return state.OrderbookMutualFundsTransactions
            .mutualFundsSIP_STP_SWP_TransactionsReducer;
    }, _.isEqual);
    var mandateDataFromRedux = useSelector(function (state) {
        return state.OrderbookMutualFundsTransactions
            .mutualFundsMandateTransactionsReducer;
    }, _.isEqual);
    var commonDataFromRedux = useSelector(function (state) {
        return state.OrderbookMutualFundsTransactions
            .mutualFundTransactionsCommonReducer;
    }, _.isEqual);
    var transferInDataFromRedux = useSelector(function (state) {
        return state.OrderbookMutualFundsTransactions.mutualFundsTransferInReducer;
    }, _.isEqual);
    // *******************************************
    // *           API FUNCTIONS                 *
    // *******************************************
    var getAllTransactionsData = function (reqPayload) {
        if (reqPayload === void 0) { reqPayload = metaDataForAllTransactionsFromRedux === null || metaDataForAllTransactionsFromRedux === void 0 ? void 0 : metaDataForAllTransactionsFromRedux.appliedFilters; }
        return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b, err_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        _a = reqPayload;
                        return [4 /*yield*/, accountDetails.getUserLoginCode()];
                    case 1:
                        _a.loginCode = _c.sent();
                        _b = reqPayload;
                        return [4 /*yield*/, accountDetails.getUserLoginType()];
                    case 2:
                        _b.loginType = _c.sent();
                        di.mutualFundOrderBook.getMutualFundOrderBook(reqPayload);
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _c.sent();
                        console.log(err_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var getSIP_STP_SWPData = function (reqPayload) {
        if (reqPayload === void 0) { reqPayload = metaDataForSIP_STP_SWP_TransactionsFromRedux === null || metaDataForSIP_STP_SWP_TransactionsFromRedux === void 0 ? void 0 : metaDataForSIP_STP_SWP_TransactionsFromRedux.appliedFilters; }
        return __awaiter(void 0, void 0, void 0, function () {
            var _a, _b, err_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 3, , 4]);
                        _a = reqPayload;
                        return [4 /*yield*/, accountDetails.getUserLoginCode()];
                    case 1:
                        _a.loginCode = _c.sent();
                        _b = reqPayload;
                        return [4 /*yield*/, accountDetails.getUserLoginType()];
                    case 2:
                        _b.loginType = _c.sent();
                        di.mutualFundOrderBook.getMFOrderbookSummary(reqPayload);
                        return [3 /*break*/, 4];
                    case 3:
                        err_2 = _c.sent();
                        console.log(err_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    var getMandatesData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var req, response, err_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setIsShowMandatesShimmer(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 5, , 6]);
                    _a = {};
                    return [4 /*yield*/, accountDetails.getUserLoginType()];
                case 2:
                    _a.loginType = _b.sent();
                    return [4 /*yield*/, accountDetails.getUserLoginCode()];
                case 3:
                    req = (_a.loginCode = _b.sent(),
                        _a.mandateStatus = [],
                        _a.mandateType = [],
                        _a);
                    return [4 /*yield*/, tocDi.mandate.getMfMandateList(req)];
                case 4:
                    response = _b.sent();
                    di.mutualFundOrderBook.updateInitialMandateData(response);
                    setIsShowMandatesShimmer(false);
                    return [3 /*break*/, 6];
                case 5:
                    err_3 = _b.sent();
                    setIsShowMandatesShimmer(false);
                    console.log(err_3);
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var resendConsentRequest = function (transactionId, invActionCode) {
        var request = {
            trxId: transactionId,
            invActionCode: Boolean(invActionCode) ? invActionCode : undefined,
        };
        orderbookDi.mutualFundOrderBook
            .sendConsentApprovalLink(request)
            .then(function () {
            productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.setToastDetails({
                isShow: true,
                isError: false,
                msg: "Resend consent link is successful",
            });
        })
            .catch(function () {
            productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.setToastDetails({
                isShow: true,
                isError: true,
                msg: "Failed to resend consent link",
            });
        });
    };
    var resendPaymentLinkRequest = function (transactionId, invActionCode) {
        var request = {
            trxId: transactionId,
            invActionCode: Boolean(invActionCode) ? invActionCode : undefined,
        };
        orderbookDi.mutualFundOrderBook
            .resendPaymentLink(request)
            .then(function () {
            productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.setToastDetails({
                isShow: true,
                isError: false,
                msg: "Resend payment link is successful",
            });
        })
            .catch(function () {
            productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.setToastDetails({
                isShow: true,
                isError: true,
                msg: "Failed to resend payment link",
            });
        });
    };
    var getAllClientOfRM = function () { return __awaiter(void 0, void 0, void 0, function () {
        var loginType, _a, _b, err_4;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, accountDetails.getUserLoginType()];
                case 1:
                    loginType = _d.sent();
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 4, , 5]);
                    _b = (_a = di.mutualFundOrderBook).getAllClientsOfRMF;
                    _c = {
                        userType: loginType === EUserRole.PARTNER
                            ? capitalizeFirstLetter(ILoginTypeEnum.PARTNER)
                            : capitalizeFirstLetter(ILoginTypeEnum.EMPLOYEE)
                    };
                    return [4 /*yield*/, accountDetails.getUserLoginCode()];
                case 3:
                    _b.apply(_a, [(_c.userId = _d.sent(),
                            _c.page = "1",
                            _c.pageSize = "100",
                            _c)]);
                    return [3 /*break*/, 5];
                case 4:
                    err_4 = _d.sent();
                    console.log(err_4);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var triggerGetCalendarData = function (startDate) { return __awaiter(void 0, void 0, void 0, function () {
        var selectedRowData, mandateCalendarPayload, resp, calendarDayAmountMap_1, err_5;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    selectedRowData = mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.filteredData.lst.find(function (item) { return item.mandateId === mandateId; });
                    mandateCalendarPayload = {
                        userId: selectedRowData === null || selectedRowData === void 0 ? void 0 : selectedRowData.accCode,
                        stDt: startDate,
                        mandateId: mandateId,
                    };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, diBasicProfile.basicProfile.mandateCalendarData(mandateCalendarPayload)];
                case 2:
                    resp = _b.sent();
                    calendarDayAmountMap_1 = new Map();
                    (_a = resp.data) === null || _a === void 0 ? void 0 : _a.mandateBalance.map(function (item) {
                        var str_date = moment(item.monthDate).format("DD MMM YYYY");
                        calendarDayAmountMap_1.set(str_date, parseInt(item.balanceAmount));
                    });
                    setDateAmountDict(calendarDayAmountMap_1);
                    return [3 /*break*/, 4];
                case 3:
                    err_5 = _b.sent();
                    console.log("err", err_5);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var triggerGetTransactionTypeData = function () { return __awaiter(void 0, void 0, void 0, function () {
        var response, err_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, di.mutualFundOrderBook.getMFOrderbookTransactionType()];
                case 1:
                    response = _a.sent();
                    if (!((response === null || response === void 0 ? void 0 : response.length) > 0)) return [3 /*break*/, 3];
                    response === null || response === void 0 ? void 0 : response.forEach(function (item) {
                        transactionTypeCodeMap[item.transactionType] =
                            item.transactionTypeCode;
                    });
                    response.unshift({
                        transactionType: EMutualFundOrderTabs.ALL_TRANSACTIONS,
                        displayOrder: 0,
                    });
                    response.push({
                        transactionType: EMutualFundOrderTabs.MANDATES,
                        displayOrder: response.length,
                    });
                    return [4 /*yield*/, checkIfARNIsAccessible()];
                case 2:
                    if (_a.sent()) {
                        response.push({
                            transactionType: EMutualFundOrderTabs.TRANSFER_IN,
                            displayOrder: response.length,
                        });
                    }
                    response.forEach(function (item, idx) {
                        item.displayOrder = idx;
                    });
                    setTransactionType(response);
                    return [3 /*break*/, 3];
                case 3: return [3 /*break*/, 5];
                case 4:
                    err_6 = _a.sent();
                    // set technial error api failure
                    console.log(err_6);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var getKebabMenuItemsAsPerCTAFlags = function (rowOfOpenedPopup, isInternal) {
        if (isInternal === void 0) { isInternal = false; }
        return __awaiter(void 0, void 0, void 0, function () {
            var updatedKebabMenuItems, showViewDetailsOrViewTransactionsOnly, resp_1, updatedPauseCount, isPauseDisabled_1, loginType, ctaPayload, selected_client, err_7;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        updatedKebabMenuItems = tempData;
                        showViewDetailsOrViewTransactionsOnly = function () {
                            if ((currentSelectedTransactionsTab ===
                                EMutualFundOrderTabs.ALL_TRANSACTIONS &&
                                rowOfOpenedPopup.displayTransactionType ===
                                    ETransactionType.SIP_INSTALLMENT) ||
                                currentSelectedTransactionsTab === EMutualFundOrderTabs.SIPs ||
                                currentSelectedTransactionsTab === EMutualFundOrderTabs.STPs ||
                                currentSelectedTransactionsTab === EMutualFundOrderTabs.SWPs) {
                                updatedKebabMenuItems = [AllKebabMenuItems.VIEW_TRANSACTION];
                            }
                            else {
                                updatedKebabMenuItems = [AllKebabMenuItems.VIEW_DETAILS];
                            }
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, 6, 7]);
                        updatedPauseCount = (rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.pauseCount) === null
                            ? 0
                            : rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.pauseCount;
                        isPauseDisabled_1 = updatedPauseCount >= (rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.pauseMaxInstallment);
                        return [4 /*yield*/, accountDetails.getUserLoginType()];
                    case 2:
                        loginType = _b.sent();
                        ctaPayload = {
                            loginType: loginType,
                            txnType: getTabIndex(currentSelectedTransactionsTab),
                            clientCode: rowOfOpenedPopup.clientCode,
                            isin: rowOfOpenedPopup.ISIN,
                            trxId: rowOfOpenedPopup.trxId,
                            invActionCode: rowOfOpenedPopup.invActionCode,
                        };
                        if ("typeOfOrder" in rowOfOpenedPopup) {
                            ctaPayload = __assign(__assign({}, ctaPayload), { typeOfOrder: rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.typeOfOrder });
                        }
                        if (!(rowOfOpenedPopup.displayTransactionType !==
                            ETransactionType.SIP_INSTALLMENT)) return [3 /*break*/, 4];
                        return [4 /*yield*/, di.mutualFundOrderBook.getMFOrderBookCtaDetail(ctaPayload)];
                    case 3:
                        resp_1 = _b.sent();
                        _b.label = 4;
                    case 4:
                        if (!isEmpty(resp_1 === null || resp_1 === void 0 ? void 0 : resp_1.data)) {
                            updatedKebabMenuItems = tempData.filter(function (item) {
                                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v;
                                switch (item.text) {
                                    case EKebebMenuItems.START_SWP:
                                        return ((_a = resp_1.data) === null || _a === void 0 ? void 0 : _a.swpFlag) == "Y";
                                    case EKebebMenuItems.START_STP:
                                        return ((_b = resp_1.data) === null || _b === void 0 ? void 0 : _b.stpFlag) === "Y";
                                    case EKebebMenuItems.START_SIP:
                                        return ((_c = resp_1.data) === null || _c === void 0 ? void 0 : _c.sipFlag) === "Y";
                                    case EKebebMenuItems.START_LUMPSUM:
                                        return ((_d = resp_1.data) === null || _d === void 0 ? void 0 : _d.purAllowedFlag) === "Y";
                                    case EKebebMenuItems.PAUSE:
                                        return ((_e = resp_1.data) === null || _e === void 0 ? void 0 : _e.pauseFlag) === "Y" ? !isPauseDisabled_1 : false;
                                    case EKebebMenuItems.REDEEM:
                                        return ((_f = resp_1.data) === null || _f === void 0 ? void 0 : _f.redAllowedFlag) === "Y";
                                    case EKebebMenuItems.SWITCH_FUND:
                                        return ((_g = resp_1.data) === null || _g === void 0 ? void 0 : _g.switchFlag) === "Y";
                                    case EKebebMenuItems.CANCEL:
                                        return (((_h = resp_1.data) === null || _h === void 0 ? void 0 : _h.cancel) === "Y" &&
                                            (rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.displayTransactionType) !==
                                                ETransactionType.SIP);
                                    case EKebebMenuItems.CANCEL_SIP:
                                        return (((_j = resp_1.data) === null || _j === void 0 ? void 0 : _j.cancel) === "Y" &&
                                            (rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.displayTransactionType) ===
                                                ETransactionType.SIP);
                                    case EKebebMenuItems.MODIFY:
                                        return ((_k = resp_1.data) === null || _k === void 0 ? void 0 : _k.modify) === "Y";
                                    case EKebebMenuItems.VIEW_DETAILS: {
                                        if (currentSelectedTransactionsTab ===
                                            EMutualFundOrderTabs.ALL_TRANSACTIONS) {
                                            return ((_l = resp_1.data) === null || _l === void 0 ? void 0 : _l.viewDetails) === "Y";
                                        }
                                        return false;
                                    }
                                    case EKebebMenuItems.DUPLICATE:
                                        return ((_m = resp_1.data) === null || _m === void 0 ? void 0 : _m.duplicate) === "Y";
                                    case EKebebMenuItems.VIEW_ALL_SIPS:
                                        return ((_o = resp_1.data) === null || _o === void 0 ? void 0 : _o.viewAllSips) === "Y";
                                    case EKebebMenuItems.VIEW_ALL_STPS:
                                        return ((_p = resp_1.data) === null || _p === void 0 ? void 0 : _p.viewAllStps) === "Y";
                                    case EKebebMenuItems.VIEW_ALL_SWPS:
                                        return ((_q = resp_1.data) === null || _q === void 0 ? void 0 : _q.viewAllSwps) === "Y";
                                    case EKebebMenuItems.PLACE_ORDER_AGAIN:
                                        return ((_r = resp_1.data) === null || _r === void 0 ? void 0 : _r.placeOrderAgain) === "Y";
                                    case EKebebMenuItems.VIEW_MANDATE_CALENDAR:
                                        return false;
                                    case EKebebMenuItems.RESEND_CONSENT_REQUEST:
                                        return ((_s = resp_1.data) === null || _s === void 0 ? void 0 : _s.resendConsentRequest) === "Y";
                                    case EKebebMenuItems.RESEND_PAYMENT_LINK:
                                        return ((_t = resp_1.data) === null || _t === void 0 ? void 0 : _t.resendPaymentLink) === "Y";
                                    case EKebebMenuItems.RESUME:
                                        return ((_u = resp_1.data) === null || _u === void 0 ? void 0 : _u.resumeFlag) === "Y";
                                    case EKebebMenuItems.VIEW_TRANSACTION:
                                        if (currentSelectedTransactionsTab === EMutualFundOrderTabs.SIPs ||
                                            currentSelectedTransactionsTab === EMutualFundOrderTabs.STPs ||
                                            currentSelectedTransactionsTab === EMutualFundOrderTabs.SWPs) {
                                            return ((_v = resp_1.data) === null || _v === void 0 ? void 0 : _v.viewDetails) === "Y";
                                        }
                                        return false;
                                    default:
                                        return true;
                                }
                            });
                        }
                        else {
                            showViewDetailsOrViewTransactionsOnly();
                        }
                        updatedKebabMenuItems = isInternal
                            ? __spreadArray([
                                {
                                    icon: "edel-icon-page-search",
                                    text: (_a = resp_1 === null || resp_1 === void 0 ? void 0 : resp_1.data) === null || _a === void 0 ? void 0 : _a.primaryCta,
                                }
                            ], __read(updatedKebabMenuItems), false) : updatedKebabMenuItems;
                        // setIsInOfScheme(rowOfOpenedPopup.scheme.isin);
                        // setIsInOfSchemeName(rowOfOpenedPopup.scheme.isinName);
                        // setSchemeCodeOfScheme(rowOfOpenedPopup.scheme.grpCode);
                        setTrxId(rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.trxId);
                        setSchemeGroupCodeOfScheme(rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.groupCode);
                        setSelectedRowSchemeDetails(rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.scheme);
                        setVendorId(rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.vendorTrxId);
                        selected_client = getSelectedClientData(rowOfOpenedPopup);
                        setClientDetailsToSidebar({
                            clientCode: rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.clientCode,
                            pan: rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.pan,
                            clientName: rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.clientName,
                            uniqueClientId: rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.ucc,
                            direct_plan_enabled_flg: selected_client === null || selected_client === void 0 ? void 0 : selected_client.direct_plan_enabled_flg,
                            dpFlag: selected_client === null || selected_client === void 0 ? void 0 : selected_client.dpFlag,
                            clientTier: rowOfOpenedPopup.clientTier,
                        });
                        return [3 /*break*/, 7];
                    case 5:
                        err_7 = _b.sent();
                        console.log("err", err_7);
                        showViewDetailsOrViewTransactionsOnly();
                        return [3 /*break*/, 7];
                    case 6:
                        setIsLoadingKebabMenuFlags(false);
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/, updatedKebabMenuItems];
                }
            });
        });
    };
    var getOrderbookTransferInTableData = function (params) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        var payload = {
            searchValue: (_a = params === null || params === void 0 ? void 0 : params.searchValue) !== null && _a !== void 0 ? _a : "",
            tabId: 0,
            clientTierId: "",
            investmentValueId: "",
            orderstatusId: (_b = params === null || params === void 0 ? void 0 : params.orderstatusId) !== null && _b !== void 0 ? _b : "",
            sync_id: (_c = selectedParams === null || selectedParams === void 0 ? void 0 : selectedParams.data) === null || _c === void 0 ? void 0 : _c.sync_id,
            uccCode: (_d = selectedParams === null || selectedParams === void 0 ? void 0 : selectedParams.data) === null || _d === void 0 ? void 0 : _d.ucccode,
            page_index: 1,
            page_size: 10,
            orderbydesc: (_e = params === null || params === void 0 ? void 0 : params.orderbydesc) !== null && _e !== void 0 ? _e : true,
            orderby: (_f = params === null || params === void 0 ? void 0 : params.orderby) !== null && _f !== void 0 ? _f : "",
            fromdate: (_g = params === null || params === void 0 ? void 0 : params.fromdate) !== null && _g !== void 0 ? _g : moment().startOf("month").format("YYYY-MM-DD"),
            todate: (_h = params === null || params === void 0 ? void 0 : params.todate) !== null && _h !== void 0 ? _h : moment().format("YYYY-MM-DD"),
        };
        di.mutualFundOrderBook.getTransferInTabData(payload);
    };
    // *******************************************
    // *           GENERATOR FUNCTIONS           *
    // *******************************************
    var generateAllTransactionsTableColumns = function () {
        return [
            {
                columnName: "Scheme Name",
                arrows: true,
                type: "string",
                applySorting: true,
                keysForCustomFunction: [
                    "scheme",
                    "toScheme",
                    "transferTo",
                    "displayTransactionType",
                ],
                sortKey: "isinName",
                tdCustomFunction: function (keys) {
                    // Pulling "displayTransactionType" as a seperate key as we have different defined interfaces for scheme/switchTo/transferTo and displayTransactionType
                    return generateSchemeName(keys, keys[3]);
                },
            },
            {
                columnName: "Client Name",
                key: "clientName",
                key2: "ucc",
                type: "string",
                applySorting: true,
                sortKey: "clientName",
                arrows: true,
                tdCustomFunction: generateClientName,
            },
            {
                columnName: "Type",
                key: "displayTransactionType",
                arrows: true,
                sortKey: "displayTransactionType",
                type: "string",
                applySorting: true,
                columnClassName: "txt-grey-shade1 DMSanN_15_400",
            },
            {
                columnName: "Date",
                key: "tableDisplayCreatedTime",
                type: "Date",
                arrows: true,
                applySorting: true,
                sortKey: "trxTime",
                arrowClassName: "justify-content-end",
                columnClassName: "text-end",
                tdCustomFunction: generateDate,
            },
            {
                columnName: (React.createElement("span", null,
                    "Amount ",
                    React.createElement("span", { className: "RobotoM_14_400" }, "(\u20B9)"))),
                key: "amount",
                arrows: true,
                sortKey: "amount",
                applySorting: true,
                arrowClassName: "justify-content-end",
                columnClassName: "text-end txt_medium-gray RobotoM_15_500",
                tdCustomFunction: function (key) { return roundUpTonDecimals(2, key, true); },
            },
            {
                columnName: "Status",
                key: "displayStatus",
                key2: "status",
                arrows: true,
                applySorting: true,
                sortKey: "displayStatus",
                type: "string",
                tdCustomFunction: generateStatus,
            },
            {
                columnName: "",
                key: "trxId",
                tdCustomFunction: function (key) { return generateTableRowActionPopup(key); },
            },
        ];
    };
    var generateSIPOrderTableColumns = function () {
        return [
            {
                columnName: "Scheme Name",
                // key: "scheme",
                arrows: true,
                type: "string",
                applySorting: true,
                keysForCustomFunction: [
                    "scheme",
                    "toScheme",
                    "transferTo",
                    "displayTransactionType",
                ],
                sortKey: "isinName",
                tdCustomFunction: function (keys) {
                    // Pulling "displayTransactionType" as a seperate key as we have different defined interfaces for scheme/switchTo/transferTo and displayTransactionType
                    return generateSchemeName(keys, keys[3]);
                },
            },
            {
                columnName: "Client Name",
                key: "clientName",
                key2: "ucc",
                type: "string",
                applySorting: true,
                sortKey: "clientName",
                arrows: true,
                tdCustomFunction: generateClientName,
            },
            {
                columnName: "Next Installment",
                key: "displayNextInstallmentDate",
                key2: "displayBankName",
                type: "Date",
                applySorting: true,
                sortKey: "displayNextInstallmentDate",
                arrows: true,
                arrowClassName: "justify-content-end",
                columnClassName: "text-end txt-grey-shade1",
            },
            {
                columnName: (React.createElement("span", null,
                    "Amount ",
                    React.createElement("span", { className: "RobotoM_14_400" }, "(\u20B9)"))),
                key: "amount",
                key2: "displayBankName",
                type: "string",
                applySorting: true,
                sortKey: "amount",
                arrows: true,
                arrowClassName: "justify-content-end",
                columnClassName: "text-end",
                tdCustomFunction: generateSIPAmount,
            },
            {
                columnName: "Status",
                key: "displayStatus",
                key2: "status",
                arrows: true,
                sortKey: "displayStatus",
                applySorting: true,
                type: "string",
                tdCustomFunction: generateStatus,
            },
            {
                columnName: "",
                key: "trxId",
                tdCustomFunction: function (key) { return generateTableRowActionPopup(key); },
            },
        ];
    };
    var generateSTPOrderTableColumns = function () {
        return [
            {
                columnName: "Scheme Name",
                arrows: true,
                type: "string",
                applySorting: true,
                keysForCustomFunction: [
                    "scheme",
                    "toScheme",
                    "transferTo",
                    "displayTransactionType",
                ],
                sortKey: "isinName",
                tdCustomFunction: function (keys) {
                    // Pulling "displayTransactionType" as a seperate key as we have different defined interfaces for scheme/switchTo/transferTo and displayTransactionType
                    return generateSchemeName(keys, keys[3]);
                },
            },
            {
                columnName: "Client Name",
                key: "clientName",
                key2: "ucc",
                type: "string",
                applySorting: true,
                sortKey: "clientName",
                arrows: true,
                tdCustomFunction: generateClientName,
            },
            {
                columnName: "Next Transfer",
                key: "nextInstallmentDate",
                sortKey: "nextInstallmentDate",
                type: "Date",
                applySorting: true,
                arrows: true,
                arrowClassName: "justify-content-end",
                columnClassName: "text-end txt-grey-shade1",
            },
            {
                columnName: (React.createElement("span", null,
                    "Amount ",
                    React.createElement("span", { className: "RobotoM_14_400" }, "(\u20B9)"))),
                key: "amount",
                type: "string",
                applySorting: true,
                sortKey: "amount",
                arrows: true,
                arrowClassName: "justify-content-end",
                columnClassName: "text-end txt_medium-gray RobotoM_15_500",
                tdCustomFunction: function (key) { return roundUpTonDecimals(2, key, true); },
            },
            {
                columnName: "Status",
                key: "displayStatus",
                key2: "status",
                arrows: true,
                applySorting: true,
                sortKey: "displayStatus",
                type: "string",
                tdCustomFunction: generateStatus,
            },
            {
                columnName: "",
                key: "trxId",
                tdCustomFunction: function (key) { return generateTableRowActionPopup(key); },
            },
        ];
    };
    var generateSWPOrderTableColumns = function () {
        return [
            {
                columnName: "Scheme Name",
                // key: "scheme",
                arrows: true,
                type: "string",
                applySorting: true,
                sortKey: "isinName",
                keysForCustomFunction: [
                    "scheme",
                    "toScheme",
                    "transferTo",
                    "displayTransactionType",
                ],
                tdCustomFunction: function (keys) {
                    // Pulling "displayTransactionType" as a seperate key as we have different defined interfaces for scheme/switchTo/transferTo and displayTransactionType
                    return generateSchemeName(keys, keys[3]);
                },
            },
            {
                columnName: "Client Name",
                key: "clientName",
                key2: "ucc",
                type: "string",
                applySorting: true,
                arrows: true,
                sortKey: "clientName",
                tdCustomFunction: generateClientName,
            },
            {
                columnName: "Next Withdrawal",
                key: "nextInstallmentDate",
                sortKey: "nextInstallmentDate",
                type: "Date",
                applySorting: true,
                arrows: true,
                columnClassName: "txt-grey-shade1 RobotoM_15_400",
            },
            {
                columnName: (React.createElement("span", null,
                    "Amount ",
                    React.createElement("span", { className: "RobotoM_14_400" }, "(\u20B9)"))),
                key: "amount",
                type: "string",
                sortKey: "amount",
                applySorting: true,
                arrows: true,
                arrowClassName: "justify-content-end",
                columnClassName: "text-end txt_medium-gray RobotoM_15_500",
                tdCustomFunction: function (key) { return roundUpTonDecimals(2, key, true); },
            },
            {
                columnName: "Status",
                key: "displayStatus",
                key2: "status",
                arrows: true,
                sortKey: "displayStatus",
                applySorting: true,
                type: "string",
                tdCustomFunction: generateStatus,
            },
            {
                columnName: "",
                key: "trxId",
                tdCustomFunction: function (key) { return generateTableRowActionPopup(key); },
            },
        ];
    };
    var generateMandatesOrderTableColumns = function () {
        return [
            {
                columnName: "Mandate ID",
                key: "mandateId",
                key2: "bankName",
                arrows: true,
                sortKey: "mandateId",
                type: "number",
                applySorting: true,
                tdCustomFunction: generateMandateId,
            },
            {
                columnName: "Client Name",
                key: "clientName",
                key2: "uccCode",
                type: "string",
                applySorting: true,
                sortKey: "clientName",
                arrows: true,
                tdCustomFunction: generateClientName,
            },
            {
                columnName: "Type",
                key: "mandateType",
                type: "string",
                applySorting: true,
                sortKey: "mandateType",
                arrows: true,
                // tdCustomFunction: generateMandateType,
            },
            {
                columnName: "Date",
                key: "dpDate",
                type: "Date",
                applySorting: true,
                arrows: true,
                sortKey: "dpDate",
                tdCustomFunction: function (key) {
                    return (React.createElement("div", { className: "d-flex flex-column gap-1 white-space-nowrap" }, key !== null && key !== void 0 ? key : "-"));
                },
            },
            {
                columnName: "Bank Name",
                key: "bankName",
                type: "string",
                applySorting: true,
                arrows: true,
                sortKey: "bankName",
            },
            {
                columnName: (React.createElement("span", null,
                    "Amount ",
                    React.createElement("span", { className: "RobotoM_14_400" }, "(\u20B9)"))),
                key: "amount",
                type: "number",
                applySorting: true,
                sortKey: "amount",
                arrows: true,
                arrowClassName: "justify-content-end",
                columnClassName: "text-end",
                tdCustomFunction: function (key, key2) { return (React.createElement("div", { className: "d-flex flex-column gap-1" },
                    React.createElement("span", null, roundUpTonDecimals(2, key, true)))); },
            },
            {
                columnName: "Status",
                key: "dpStatus",
                key2: "status",
                arrows: true,
                sortKey: "dpStatus",
                type: "string",
                applySorting: true,
                tdCustomFunction: generateStatus,
            },
            {
                columnName: "",
                key: "mandateId",
                key2: "mandateType",
                key3: "dpStatus",
                tdCustomFunction: function (mandateId, mandateType, dpStatus) {
                    return (
                    // dpStatus === EMandateStatuses.ACTIVE &&
                    generateTableRowActionPopupForMandate(mandateId, mandateType, dpStatus));
                },
            },
        ];
    };
    var generateTransferInTableColumns = function () {
        return [
            {
                columnName: "Client Name/PAN",
                arrows: true,
                type: "string",
                applySorting: true,
                keysForCustomFunction: ["ac_name", "pan", "client_tier"],
                sortKey: "ac_name",
                tdCustomFunction: function (keys) {
                    var _a;
                    return (React.createElement(GenericSchemeName, { name: keys[0], subText1: keys[1], badgeIcon: generateClientTierIcon(keys[2]), showImage: true, parentClassName: (_a = keys[2]) === null || _a === void 0 ? void 0 : _a.toLowerCase(), textAndBackgroundColorCollectionConfig: alphabetsColorsConfigMap, maxWidth: 335, showTooltip: true }));
                },
            },
            {
                columnName: "Scheme Name",
                type: "string",
                applySorting: true,
                sortKey: "sch_name",
                arrows: true,
                keysForCustomFunction: ["sch_name", "isin_code"],
                tdCustomFunction: function (keys) {
                    return generateClientName(keys[0], keys[1]);
                },
            },
            {
                columnName: "Folio No.",
                key: "folio_no",
                arrows: true,
                sortKey: "folio_no",
                type: "string",
                applySorting: true,
                arrowClassName: "justify-content-end",
                columnClassName: "text-end txt_medium-gray RobotoM_15_500",
            },
            {
                columnName: "Date",
                key: "placed_on",
                type: "string",
                arrows: true,
                applySorting: true,
                sortKey: "placed_on",
                arrowClassName: "justify-content-end",
                columnClassName: "text-end",
                tdCustomFunction: function (key) {
                    return (React.createElement("div", { className: "d-flex flex-column gap-1 text-left text-end white-space-nowrap" },
                        React.createElement("span", { className: "txt-grey-shade1 RobotoM_15_400" }, moment(key).format("DD MMM YY")),
                        React.createElement("span", { className: "txt_purple-gray RobotoM_14_300" }, moment(key).format("hh:mm:ss A"))));
                },
            },
            {
                columnName: "Available Units",
                key: "aval_unit",
                arrows: false,
                sortKey: "aval_unit",
                applySorting: false,
                arrowClassName: "justify-content-end",
                columnClassName: "text-end txt_medium-gray RobotoM_15_500",
                // tdCustomFunction: (key: string) => roundUpTonDecimals(2, key, true),
            },
            {
                columnName: (React.createElement("span", null,
                    "Current Value ",
                    React.createElement("span", { className: "RobotoM_14_400" }, "(\u20B9)"))),
                key: "current_value",
                arrows: true,
                sortKey: "current_value",
                applySorting: true,
                arrowClassName: "justify-content-end",
                columnClassName: "text-end txt_medium-gray RobotoM_15_500",
                tdCustomFunction: function (key) { return (React.createElement("div", { className: "d-flex flex-column gap-1" },
                    React.createElement("span", null, roundUpTonDecimals(4, key, true)))); },
            },
            {
                columnName: "Status",
                key: "status",
                arrows: true,
                applySorting: true,
                sortKey: "status",
                type: "string",
                tdCustomFunction: function (key) {
                    return (React.createElement(GenericStatus, { statusText: key, statusType: generateStatusTypeForTransferInTable(key), parentClassName: "DMsanL_15_300 white-space-nowrap" }));
                },
            },
            {
                columnName: "",
                keysForCustomFunction: ["ucccode", "placed_on", "sch_name"],
                trCustomFunction: function (row) {
                    return generateRowActionPopupForTrasnferInTable(row, (row === null || row === void 0 ? void 0 : row.ucccode) + (row === null || row === void 0 ? void 0 : row.placed_on) + (row === null || row === void 0 ? void 0 : row.sch_name));
                },
            },
        ];
    };
    var generateSchemeName = function (values, status) {
        var _a, _b;
        if (!!values[0] &&
            status !== ETransactionType.SWITCH &&
            status !== ETransactionType.STP) {
            return (React.createElement("div", { className: "ob-scheme-name-tooltip" },
                React.createElement(GenericSchemeName, { name: (_a = values[0].isinName) !== null && _a !== void 0 ? _a : values[0].schemeName, subText1: values[0].catName, subText2: values[0].subCatName, showImage: true, maxWidth: 335, image: (_b = values[0]) === null || _b === void 0 ? void 0 : _b.amcLogo, showTooltip: true, tooltipClassName: "scheme-name-tooltip", highlightSchemeNameOnHover: true, tooltipPlacement: "top-start" })));
        }
        // switch to
        if (!!values[1]) {
            return (React.createElement(OrderBookSideBarHeader, { schemeDetails: {
                    schemeName: values[0].isinName,
                    catName: values[0].catName,
                    subCatName: values[0].subCatName,
                    amcLogo: values[0].amcLogo,
                }, maxWidth: 95, maxWidthUnit: "%", toSchemeDetails: {
                    schemeName: values[1].isinName,
                    catName: values[1].catName,
                    subCatName: values[1].subCatName,
                }, trxType: status, parentClassName: "orderbook-table-switch-transfer-scheme-name", highlightSchemeNameOnHover: true }));
        }
        return React.createElement(React.Fragment, null);
    };
    var generateDate = function (displayData) {
        var splitArr = displayData.split(" ");
        var date = splitArr.slice(0, 3).join(" ");
        var time = splitArr.slice(3).join(" ");
        return displayData ? (React.createElement("div", { className: "d-flex flex-column gap-1 text-left text-end white-space-nowrap" },
            React.createElement("span", { className: "txt-grey-shade1 RobotoM_15_400" }, date),
            React.createElement("span", { className: "txt_purple-gray RobotoM_14_300" }, time))) : ("-");
    };
    var generateClientName = function (clientName, ucc) {
        return (React.createElement("div", { className: "d-flex flex-column gap-1 client-data-wrapper" },
            React.createElement("span", { className: "txt-grey-shade1 client-name-wrapper DMSanN_15_400", title: clientName }, clientName),
            React.createElement("span", { className: "txt_purple-gray RobotoM_14_300" }, ucc)));
    };
    var generateStatus = function (statusText, statusType) {
        return (React.createElement(GenericStatus, { statusText: capitalizeFirstLetter(statusText), statusType: orderBookStatusType[statusText], parentClassName: "DMsanL_15_300 white-space-nowrap" }));
    };
    var generateSIPAmount = function (amount, displayBankName) {
        {
            return (React.createElement("div", { className: "d-flex flex-column gap-1 text-end txt_medium-gray" },
                React.createElement("span", { className: "txt_medium-gray RobotoM_15_500" }, roundUpTonDecimals(2, amount, true)),
                React.createElement("span", { className: "Roboto_15_300" }, displayBankName)));
        }
    };
    var generateTableRowActionPopup = function (transactionId) {
        return (React.createElement("span", { id: transactionId, className: "edel-icon-kabab-menu mf-transactions-row-actions-wrapper ".concat(tableRowActionPopupConfig.containerId === transactionId
                ? "active-menu"
                : ""), onClick: handleAll_SIP_STP_SWPTableRowThreeDotsClick(transactionId) }));
    };
    var generateMandateId = function (mandateId, bankName) {
        // const maskedMandateId = !!mandateId ? mandateId?.slice(-4) : "";
        return "".concat(bankName, " - ").concat(mandateId);
    };
    var generateMandateType = function (mandateType) {
        switch (mandateType) {
            case EMandateType.PHYSICAL:
                return "Physical";
            case EMandateType.EMANDATE:
                return "Digital";
            default:
                return "";
        }
        return;
    };
    var generateTableRowActionPopupForMandate = function (rowMandateId, mandateType, dpStatus) {
        if (dpStatus !== EMandateStatuses.ACTIVE)
            return null;
        return (React.createElement("span", { id: rowMandateId, className: "edel-icon-kabab-menu mf-transactions-row-actions-wrapper ".concat(tableRowActionPopupConfig.containerId === rowMandateId
                ? "active-menu"
                : ""), onClick: handleMandateTableThreeDotClick(rowMandateId, mandateType, dpStatus) }));
    };
    var generateInvestmentTypeFilter = function () {
        var _a;
        return (React.createElement("div", { className: "d-flex flex-column order-status-checkbox-filters-container" },
            React.createElement("div", { className: "d-flex justify-content-end orderbook-summary-select-all-filters-btn-container" },
                React.createElement(EdButton, { btnTyp: "text-only", value: ((_a = allTransactionsFilter === null || allTransactionsFilter === void 0 ? void 0 : allTransactionsFilter.investType) === null || _a === void 0 ? void 0 : _a.length) > 1
                        ? "Deselect All"
                        : "Select All", className: "text-right p-10 txt-han-blue orderbook-summary-select-all-filters-btn DMsanL_12_300", onClick: function () {
                        var _a, _b, _c;
                        return handleSelectAllTransactionsInvestmentTypeFilters(((_a = allTransactionsFilter === null || allTransactionsFilter === void 0 ? void 0 : allTransactionsFilter.investType) === null || _a === void 0 ? void 0 : _a.length) > 1 &&
                            ((_b = allTransactionsFilter === null || allTransactionsFilter === void 0 ? void 0 : allTransactionsFilter.investType) === null || _b === void 0 ? void 0 : _b.length) <
                                (investmentTypeFilter === null || investmentTypeFilter === void 0 ? void 0 : investmentTypeFilter.length)
                            ? true
                            : (investmentTypeFilter === null || investmentTypeFilter === void 0 ? void 0 : investmentTypeFilter.length) ===
                                ((_c = allTransactionsFilter === null || allTransactionsFilter === void 0 ? void 0 : allTransactionsFilter.investType) === null || _c === void 0 ? void 0 : _c.length));
                    } })),
            React.createElement("div", null, investmentTypeFilter === null || investmentTypeFilter === void 0 ? void 0 : investmentTypeFilter.map(function (item) {
                var _a;
                return (React.createElement(GenericCheckbox, { checkboxType: "han-blue", parentClassName: "orderbook-summary-checkbox-filter", checkboxProps: {
                        checked: (_a = allTransactionsFilter === null || allTransactionsFilter === void 0 ? void 0 : allTransactionsFilter.investType) === null || _a === void 0 ? void 0 : _a.includes(item.value),
                        value: item.value,
                        name: "investType",
                        onChange: function (e) {
                            return handleAllTransactionsCheckboxFiltersChange(e);
                        },
                    }, labelProps: {
                        children: item.label,
                        className: "DMsanL_12_300",
                    } }));
            }))));
    };
    var generateAllTransactionsOrderStatusFilters = function () {
        var _a, _b;
        return (React.createElement("div", { className: "d-flex flex-column order-status-checkbox-filters-container" },
            React.createElement("div", { className: "d-flex justify-content-end orderbook-summary-select-all-filters-btn-container" },
                React.createElement(EdButton, { btnTyp: "text-only", value: ((_a = allTransactionsFilter === null || allTransactionsFilter === void 0 ? void 0 : allTransactionsFilter.status) === null || _a === void 0 ? void 0 : _a.length) > 1
                        ? "Deselect All"
                        : "Select All", className: "text-right p-10 txt-han-blue orderbook-summary-select-all-filters-btn DMsanL_12_300", onClick: function () {
                        var _a, _b, _c, _d, _e;
                        return handleSelectAllOrderStatus(((_a = allTransactionsFilter === null || allTransactionsFilter === void 0 ? void 0 : allTransactionsFilter.status) === null || _a === void 0 ? void 0 : _a.length) > 1 &&
                            ((_b = allTransactionsFilter === null || allTransactionsFilter === void 0 ? void 0 : allTransactionsFilter.status) === null || _b === void 0 ? void 0 : _b.length) <
                                ((_c = allTransactionsDataFromRedux === null || allTransactionsDataFromRedux === void 0 ? void 0 : allTransactionsDataFromRedux.tranSummaryList) === null || _c === void 0 ? void 0 : _c.length)
                            ? true
                            : ((_d = allTransactionsDataFromRedux === null || allTransactionsDataFromRedux === void 0 ? void 0 : allTransactionsDataFromRedux.tranSummaryList) === null || _d === void 0 ? void 0 : _d.length) ===
                                ((_e = allTransactionsFilter === null || allTransactionsFilter === void 0 ? void 0 : allTransactionsFilter.status) === null || _e === void 0 ? void 0 : _e.length));
                    } })),
            React.createElement("div", null, (_b = allTransactionsDataFromRedux === null || allTransactionsDataFromRedux === void 0 ? void 0 : allTransactionsDataFromRedux.tranSummaryList) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                var _a;
                return (React.createElement(GenericCheckbox, { checkboxType: "han-blue", parentClassName: "orderbook-summary-checkbox-filter", checkboxProps: {
                        checked: (_a = allTransactionsFilter === null || allTransactionsFilter === void 0 ? void 0 : allTransactionsFilter.status) === null || _a === void 0 ? void 0 : _a.includes(item.status),
                        value: item.status,
                        name: "status",
                        onChange: function (e) {
                            return handleAllTransactionsCheckboxFiltersChange(e);
                        },
                    }, labelProps: {
                        children: item.status,
                        className: "DMsanL_12_300",
                    } }));
            }))));
    };
    var generateAllTransactionsClientNamesFilters = function () {
        return (React.createElement("div", { className: "client-names-radio-filters-container" },
            React.createElement(FundSearchPanel, { placeholder: "Search by client name", applySearchedFilters: handleSearchClientsInFilters, searchValue: searchedClient }),
            React.createElement("div", { className: "d-flex flex-column" }, (localClientsList === null || localClientsList === void 0 ? void 0 : localClientsList.length) ? (localClientsList === null || localClientsList === void 0 ? void 0 : localClientsList.map(function (item) {
                var _a;
                return (React.createElement(RadioButton, { key: nanoid(), list: {
                        display: (React.createElement(ClientNamesWithClientCodes, { clientName: item.clientName, clientCode: item.accountCode, wrapClientName: true })),
                        value: item.accountCode,
                    }, selected: ((_a = allTransactionsFilter === null || allTransactionsFilter === void 0 ? void 0 : allTransactionsFilter.clientCodes) === null || _a === void 0 ? void 0 : _a.length)
                        ? allTransactionsFilter.clientCodes[0]
                        : "", name: "clientCodes", onChange: function (e) { return handleAllTransactionsRadioFiltersChange(e); } }));
            })) : (React.createElement(BasicErrorMessage, { primaryText: "No results found!", subText: "Try searching for something else or explore other options." })))));
    };
    var generateSIP_STP_SWP_TransactionsOrderStatusFilters = function () {
        var _a, _b;
        return (React.createElement("div", { className: "d-flex flex-column order-status-checkbox-filters-container" },
            React.createElement("div", { className: "d-flex justify-content-end orderbook-summary-select-all-filters-btn-container" },
                React.createElement(EdButton, { btnTyp: "text-only", value: ((_a = SIP_STP_SWP_TransactionsFilter === null || SIP_STP_SWP_TransactionsFilter === void 0 ? void 0 : SIP_STP_SWP_TransactionsFilter.status) === null || _a === void 0 ? void 0 : _a.length) > 1
                        ? "Deselect All"
                        : "Select All", className: "text-right p-10 txt-han-blue orderbook-summary-select-all-filters-btn DMsanL_12_300", onClick: function () {
                        var _a, _b, _c, _d, _e;
                        return handleSelectAllOrderStatus(((_a = SIP_STP_SWP_TransactionsFilter === null || SIP_STP_SWP_TransactionsFilter === void 0 ? void 0 : SIP_STP_SWP_TransactionsFilter.status) === null || _a === void 0 ? void 0 : _a.length) > 1 &&
                            ((_b = SIP_STP_SWP_TransactionsFilter === null || SIP_STP_SWP_TransactionsFilter === void 0 ? void 0 : SIP_STP_SWP_TransactionsFilter.status) === null || _b === void 0 ? void 0 : _b.length) <
                                ((_c = SIP_STP_SWP_TransactionsDataFromRedux === null || SIP_STP_SWP_TransactionsDataFromRedux === void 0 ? void 0 : SIP_STP_SWP_TransactionsDataFromRedux.tranSummaryList) === null || _c === void 0 ? void 0 : _c.length)
                            ? true
                            : ((_d = SIP_STP_SWP_TransactionsDataFromRedux === null || SIP_STP_SWP_TransactionsDataFromRedux === void 0 ? void 0 : SIP_STP_SWP_TransactionsDataFromRedux.tranSummaryList) === null || _d === void 0 ? void 0 : _d.length) ===
                                ((_e = SIP_STP_SWP_TransactionsFilter === null || SIP_STP_SWP_TransactionsFilter === void 0 ? void 0 : SIP_STP_SWP_TransactionsFilter.status) === null || _e === void 0 ? void 0 : _e.length));
                    } })),
            React.createElement("div", null, (_b = SIP_STP_SWP_TransactionsDataFromRedux === null || SIP_STP_SWP_TransactionsDataFromRedux === void 0 ? void 0 : SIP_STP_SWP_TransactionsDataFromRedux.tranSummaryList) === null || _b === void 0 ? void 0 : _b.map(function (item) {
                var _a;
                return (React.createElement(GenericCheckbox, { checkboxType: "han-blue", parentClassName: "orderbook-summary-checkbox-filter", checkboxProps: {
                        checked: (_a = SIP_STP_SWP_TransactionsFilter === null || SIP_STP_SWP_TransactionsFilter === void 0 ? void 0 : SIP_STP_SWP_TransactionsFilter.status) === null || _a === void 0 ? void 0 : _a.includes(item.status),
                        name: "status",
                        value: item.status,
                        onChange: function (e) { return handleSIP_STP_SWP_CheckboxFiltersChange(e); },
                    }, labelProps: {
                        children: item.status,
                        className: "DMsanL_12_300",
                    } }));
            }))));
    };
    var generateSIP_STP_SWP_TransactionsClientNamesFilters = function () {
        return (React.createElement("div", { className: "client-names-radio-filters-container" },
            React.createElement(FundSearchPanel, { placeholder: "Search by client name", applySearchedFilters: handleSearchClientsInFilters, searchValue: searchedClient }),
            React.createElement("div", { className: "d-flex flex-column" }, (localClientsList === null || localClientsList === void 0 ? void 0 : localClientsList.length) ? (localClientsList === null || localClientsList === void 0 ? void 0 : localClientsList.map(function (item) {
                var _a;
                return (React.createElement(RadioButton, { key: nanoid(), list: {
                        display: (React.createElement(ClientNamesWithClientCodes, { clientName: item.clientName, clientCode: item.accountCode, wrapClientName: true })),
                        value: item.accountCode,
                    }, selected: ((_a = SIP_STP_SWP_TransactionsFilter === null || SIP_STP_SWP_TransactionsFilter === void 0 ? void 0 : SIP_STP_SWP_TransactionsFilter.clientCodes) === null || _a === void 0 ? void 0 : _a.length)
                        ? SIP_STP_SWP_TransactionsFilter.clientCodes[0]
                        : "", name: "clientCodes", onChange: function (e) { return handleSIP_STP_SWP_RadioFiltersChange(e); } }));
            })) : (React.createElement(BasicErrorMessage, { primaryText: "No results found!", subText: "Try searching for something else or explore other options." })))));
    };
    var generateSearchAndFilterPanel = function (dataProps) {
        var _a, _b, _c;
        return (React.createElement(SearchPanelWithPopupFiltersLabel, { parentClassName: "mb-20", searchBarParentClassName: "w-400", autoComplete: "off", isShowPopup: dataProps.isShowPop, setIsShowPopup: dataProps.isShowPopupCallback, searchValue: (_a = dataProps.filtersData) === null || _a === void 0 ? void 0 : _a.searchText, applySearchedFilters: dataProps.applySearchingCallback, clearSearching: props === null || props === void 0 ? void 0 : props.clearSearching, placeholder: "Search by fund name, client name, type...", disableDefaultDebounce: true, enableOnChangeFunctionInUseEffect: false, rightSubComponent: React.createElement(React.Fragment, null,
                React.createElement(MFOrderbookCalendarFilter, { filtersData: dataProps.filtersData, handleApplyCallback: dataProps.applyCallbackForCalendarFilters, handleFilterChangeCallback: dataProps.filterChangeCallbackForCalendarFilters }),
                !(currentSelectedTransactionsTab ===
                    EMutualFundOrderTabs.MANDATES ||
                    currentSelectedTransactionsTab ===
                        EMutualFundOrderTabs.TRANSFER_IN) && (React.createElement(ExcelPdfDownload, { excelDownloadLoader: excelDownloadLoader, handleExcelDownloadCallback: handleDownloadExcel, isShowExportPopup: isShowExportPopup, setIsShowExportPopup: setIsShowExportPopup }))), filterComponentInsidePopup: currentSelectedTransactionsTab ===
                EMutualFundOrderTabs.TRANSFER_IN ? (React.createElement(TransferInFilters, { filtersData: (_c = (_b = transferInDataFromRedux === null || transferInDataFromRedux === void 0 ? void 0 : transferInDataFromRedux.transferInData) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c[0], handleApplyCallback: function (item) {
                    var _a, _b;
                    getOrderbookTransferInTableData({
                        orderstatusId: ((_b = (_a = item === null || item === void 0 ? void 0 : item.orderBookStatus) === null || _a === void 0 ? void 0 : _a.map(function (item) { return item.value; })) === null || _b === void 0 ? void 0 : _b.join(",")) || "",
                    });
                    di.mutualFundOrderBook.updateTransferInFilters({
                        orderBookStatus: item === null || item === void 0 ? void 0 : item.orderBookStatus,
                    });
                    setIsShowFilterPopup(false);
                }, handleCancelCallback: function () {
                    setIsShowFilterPopup(false);
                }, handleClearAllCallback: function () {
                    getOrderbookTransferInTableData({
                        orderstatusId: "",
                    });
                    di.mutualFundOrderBook.updateTransferInFilters({
                        orderBookStatus: [],
                    });
                    setIsShowFilterPopup(false);
                }, activeFilter: transferInDataFromRedux === null || transferInDataFromRedux === void 0 ? void 0 : transferInDataFromRedux.appliedFilters })) : (React.createElement(VerticalFilterTabs, { tabsList: dataProps.tabsList, applyBtnCallback: dataProps.applyCallbackForFilters, clearAllBtnCallback: dataProps.clearAllFiltersCallback, cancelBtnCallback: dataProps.cancelCallback })), filterLabels: dataProps.filterLabels, removeFilterThroughLabels: function (value, keyName, subKeyName) {
                return dataProps.removeLabelsCallback(value, keyName, subKeyName, dataProps.filtersData);
            }, isViewAllTrue: true }));
    };
    var generateFiltersLoaderOrErrorUI = function (loader, dataForFilterFunction, filterUIGeneratorFunction) {
        if (loader) {
            return (React.createElement("div", { className: "d-flex align-items-center justify-content-center h-100" },
                React.createElement(Spinner, { animation: "border", variant: "primary" })));
        }
        else {
            return (dataForFilterFunction === null || dataForFilterFunction === void 0 ? void 0 : dataForFilterFunction.length) ? (filterUIGeneratorFunction()) : (React.createElement(BasicErrorMessage, { primaryText: "No results found!" }));
        }
    };
    var generatePropsForSearchPanel = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
        var localPropsObj = {
            isShowPop: isShowFilterPopup,
            isShowPopupCallback: undefined,
            applySearchingCallback: undefined,
            filtersData: undefined,
            applyCallbackForCalendarFilters: undefined,
            filterChangeCallbackForCalendarFilters: undefined,
            tabsList: [],
            applyCallbackForFilters: undefined,
            clearAllFiltersCallback: undefined,
            cancelCallback: undefined,
            filterLabels: [],
            removeLabelsCallback: undefined,
        };
        switch (currentSelectedTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                localPropsObj = __assign(__assign({}, localPropsObj), { isShowPopupCallback: handleCancelApplyingAllTransactionsFilter, applySearchingCallback: handleApplySearchForAllTransactions, filtersData: allTransactionsFilter, applyCallbackForCalendarFilters: handleApplyCalendarFilterForAllTransactions, filterChangeCallbackForCalendarFilters: handleUpdateAllTransactionsFilter, tabsList: allTransactionsFilterTabs, applyCallbackForFilters: handleApplyAllTransactionsFilters, clearAllFiltersCallback: handleClearAllTransactionsFilter, cancelCallback: handleCancelApplyingAllTransactionsFilter, filterLabels: allTransactionsFilterLabels, removeLabelsCallback: handleRemoveAllTransactionsFiltersThroughLabels });
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.SWPs:
            case EMutualFundOrderTabs.STPs:
                localPropsObj = __assign(__assign({}, localPropsObj), { isShowPopupCallback: handleCancelApplyingSIP_STP_SWP_Filter, applySearchingCallback: handleApplySearchForSIP_STP_SWP_Transactions, filtersData: SIP_STP_SWP_TransactionsFilter, applyCallbackForCalendarFilters: handleApplyCalendarFilterForSIP_STP_SWPTransactions, filterChangeCallbackForCalendarFilters: handleUpdateSIP_STP_SWP_Filter, tabsList: SIP_TransactionsFilterTabs, applyCallbackForFilters: handleApplySIP_STP_SWP_TransactionsFilters, clearAllFiltersCallback: handleClearSIP_STP_SWP_Filter, cancelCallback: handleCancelApplyingSIP_STP_SWP_Filter, filterLabels: SIP_STP_SWP_FilterLabels, removeLabelsCallback: handleRemoveSIP_STP_SWP_FiltersThroughLabels });
                break;
            case EMutualFundOrderTabs.MANDATES:
                localPropsObj = __assign(__assign({}, localPropsObj), { isShowPopupCallback: handleCancelApplyingMandatesFilters, applySearchingCallback: handleApplySearchForMandates, filtersData: __assign({ searchText: mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.searchText }, (!!(mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData) && __assign(__assign(__assign({}, mandatesFilters.filteredData), (((_a = mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData) === null || _a === void 0 ? void 0 : _a.dpDate) &&
                        ((_c = (_b = mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData) === null || _b === void 0 ? void 0 : _b.dpDate) === null || _c === void 0 ? void 0 : _c.fromDate) && {
                        fromDate: (_f = (_e = (_d = mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData) === null || _d === void 0 ? void 0 : _d.dpDate) === null || _e === void 0 ? void 0 : _e.fromDate) === null || _f === void 0 ? void 0 : _f.filterValue,
                    })), (((_g = mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData) === null || _g === void 0 ? void 0 : _g.dpDate) &&
                        ((_j = (_h = mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData) === null || _h === void 0 ? void 0 : _h.dpDate) === null || _j === void 0 ? void 0 : _j.toDate) && {
                        toDate: (_m = (_l = (_k = mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData) === null || _k === void 0 ? void 0 : _k.dpDate) === null || _l === void 0 ? void 0 : _l.toDate) === null || _m === void 0 ? void 0 : _m.filterValue,
                    })))), applyCallbackForCalendarFilters: function () { }, filterChangeCallbackForCalendarFilters: handleMandateCalendarFilterChange, tabsList: mandateTransactionsFiltersTabs, applyCallbackForFilters: function () {
                        return handleApplyMandateFilters(mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData);
                    }, clearAllFiltersCallback: handleClearAllMandateFilters, cancelCallback: handleCancelApplyingMandatesFilters, filterLabels: mandateFilterLabels, removeLabelsCallback: handleRemoveMandateFiltersThroughLabels });
                break;
            case EMutualFundOrderTabs.TRANSFER_IN:
                localPropsObj = __assign(__assign({}, localPropsObj), { isShowPopupCallback: function (isShowPopup) {
                        if (isShowPopup === void 0) { isShowPopup = false; }
                        setIsShowFilterPopup(isShowPopup);
                    }, applySearchingCallback: handleApplySearchForTransferIn, applyCallbackForCalendarFilters: handleApplyTransferInCalendarFilters, filtersData: __assign(__assign({}, (_p = (_o = transferInDataFromRedux === null || transferInDataFromRedux === void 0 ? void 0 : transferInDataFromRedux.transferInData) === null || _o === void 0 ? void 0 : _o.data) === null || _p === void 0 ? void 0 : _p[0]), { fromDate: moment().startOf("month").format("YYYY-MM-DD"), toDate: moment().format("YYYY-MM-DD") }), cancelCallback: function () {
                        setIsShowFilterPopup(false);
                    }, clearAllFiltersCallback: function () {
                        getOrderbookTransferInTableData({
                            orderstatusId: "",
                        });
                        setIsShowFilterPopup(false);
                    } });
                break;
        }
        return localPropsObj;
    };
    var generateStatusTypeForTransferInTable = function (status) {
        if ((status === null || status === void 0 ? void 0 : status.toLowerCase()) === EStatusTypeForTransferInTable.IN_PROGRESS) {
            return EGenericStatusType.WARNING;
        }
        else if ((status === null || status === void 0 ? void 0 : status.toLowerCase()) === EStatusTypeForTransferInTable.EXPIRED) {
            return EGenericStatusType.DANGER;
        }
        else if ((status === null || status === void 0 ? void 0 : status.toLowerCase()) === EStatusTypeForTransferInTable.COMPLETED) {
            return EGenericStatusType.SUCCESS;
        }
        else
            return EGenericStatusType.WARNING;
    };
    var generateRowActionPopupForTrasnferInTable = function (row, containerID) {
        return (React.createElement("span", { id: containerID, className: "edel-icon-kabab-menu mf-transactions-row-actions-wrapper ".concat(tableRowActionPopupConfig.containerId === containerID
                ? "active-menu"
                : ""), onClick: handleTransferInTableRowThreeDotsClick(row, containerID) }));
    };
    var handleTransferInTableRowThreeDotsClick = function (row, containerID) {
        return function (e) {
            e.stopPropagation();
            e.preventDefault();
            setTableRowThreeDotActionPopupList([tempData[0]]);
            setTableRowActionPopupConfig({
                isShowPopup: true,
                containerId: containerID,
            });
            setSelectedViewDetailsTransferIn(row);
        };
    };
    // *******************************************
    // *           HANDLER FUNCTIONS             *
    // *******************************************
    var handleTabChange = function (selectedTab) {
        // setOrderSummaryData(undefined);
        // handleUpdateAllTransactionsFilter({
        //   ...allTransactionsFilter,
        //   searchText: ``,
        // });
        // handleUpdateSIP_STP_SWP_Filter({
        //   ...SIP_STP_SWP_TransactionsFilter,
        //   searchText: ``,
        // });
        switch (selectedTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                var data = metaDataForAllTransactionsFromRedux === null || metaDataForAllTransactionsFromRedux === void 0 ? void 0 : metaDataForAllTransactionsFromRedux.appliedFilters;
                SIP_STP_SWP_FilterLabels.length &&
                    handleUpdateSIP_STP_SWP_FilterLabels([]);
                di.mutualFundOrderBook.resetSIP_STP_SWP_TransactionsFiltersAndSearch();
                di.mutualFundOrderBook.resetMandateFiltersAndSearch();
                getAllTransactionsData(data);
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                handleSet_SIP_STP_SWP_tabData(selectedTab);
                break;
            case EMutualFundOrderTabs.MANDATES:
                di.mutualFundOrderBook.clearSIP_STP_SWP_Filters();
                di.mutualFundOrderBook.clearAllTransactionsFilters();
                getMandatesData();
                break;
            case EMutualFundOrderTabs.TRANSFER_IN:
                di.mutualFundOrderBook.updateTransferInFilters({ orderBookStatus: [] });
                getOrderbookTransferInTableData();
                break;
        }
        setSelectedRowSchemeDetails(null);
        // setIsInOfScheme("");
        // setIsInOfSchemeName("");
        di.mutualFundOrderBook.updateCurrentSelectedTransactionTab(selectedTab);
        if (leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderId) {
            leadRedirectionState.orderId = "";
            leadRedirectionState.categoryCode = "";
            leadRedirectionState.orderDate = "";
            leadRedirectionState.productCode = "";
            leadRedirectionState.productType = -1;
            navigate(".", { replace: true }); // clearing location state
        }
        // setSelectedTransactionTab(selectedTab);
    };
    var handleUpdateAllTransactionsFilter = function (data) {
        // This function is to update all transactions filter state
        setAllTransactionsFilter(data);
    };
    var handleUpdateSIP_STP_SWP_Filter = function (data) {
        // This function is to update SIP, STP and SWP filter state
        setSIP_STP_SWP_TransactionsFilter(data);
    };
    var handleUpdateMandateFiltersData = function (data) {
        // This function is to update mandate filter state
        setMandatesFilters(__assign({}, data));
    };
    var handleUpdateAllTransactionsFilterLabels = function (data) {
        // This function is to update the filter labels state for all transactions tab
        setAllTransactionsFilterLabels(data);
    };
    var handleUpdateSIP_STP_SWP_FilterLabels = function (data) {
        // This function is to update the filter labels state for SIP, STP and SWP tabs
        setSIP_STP_SWP_FilterLabels(data);
    };
    var handleUpdateMandateFilterLabels = function (data) {
        // This function is to update the filter labels state for mandates tabs
        setMandateFilterLabels(data);
    };
    var handleAllTransactionsCheckboxFiltersChange = function (e) {
        var _a, _b;
        var localFilters = __assign({}, allTransactionsFilter);
        if (e.target.checked) {
            (_a = localFilters[e.target.name]) === null || _a === void 0 ? void 0 : _a.push(e.target.value);
        }
        else {
            localFilters[e.target.name] = (_b = localFilters[e.target.name]) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return item !== e.target.value; });
        }
        handleUpdateAllTransactionsFilter(localFilters);
    };
    var handleAllTransactionsRadioFiltersChange = function (e) {
        var _a;
        var localFilters = __assign({}, allTransactionsFilter);
        if (!((_a = localFilters[e.target.name]) === null || _a === void 0 ? void 0 : _a.includes(e.target.value))) {
            localFilters[e.target.name] = [];
            localFilters[e.target.name].push(e.target.value);
        }
        handleUpdateAllTransactionsFilter(localFilters);
    };
    var handleSIP_STP_SWP_CheckboxFiltersChange = function (e) {
        var _a, _b;
        var localFilters = __assign({}, SIP_STP_SWP_TransactionsFilter);
        if (e.target.checked) {
            (_a = localFilters[e.target.name]) === null || _a === void 0 ? void 0 : _a.push(e.target.value);
        }
        else {
            localFilters[e.target.name] =
                (_b = localFilters[e.target.name]) === null || _b === void 0 ? void 0 : _b.filter(function (item) { return item !== e.target.value; });
        }
        handleUpdateSIP_STP_SWP_Filter(localFilters);
    };
    var handleSIP_STP_SWP_RadioFiltersChange = function (e) {
        var _a;
        var localFilters = __assign({}, SIP_STP_SWP_TransactionsFilter);
        if (!((_a = localFilters[e.target.name]) === null || _a === void 0 ? void 0 : _a.includes(e.target.value))) {
            localFilters[e.target.name] =
                [];
            localFilters[e.target.name].push(e.target.value);
        }
        handleUpdateSIP_STP_SWP_Filter(localFilters);
    };
    var handleApplyAllTransactionsFilters = function () {
        di.mutualFundOrderBook.updateAllTransactionsFilters(allTransactionsFilter);
        handleCreateFilterLabelsForAllTransactionsTab();
        setIsShowFilterPopup(false);
        getAllTransactionsData(allTransactionsFilter);
    };
    var handleClearAllTransactionsFilter = function () {
        var _a, _b, _c;
        di.mutualFundOrderBook.clearAllTransactionsFilters();
        handleUpdateAllTransactionsFilterLabels([]);
        setIsShowFilterPopup(false);
        getAllTransactionsData(__assign(__assign({}, JSON.parse(JSON.stringify(allTransactionInitialData.appliedFilters))), { fromDate: (_a = metaDataForAllTransactionsFromRedux === null || metaDataForAllTransactionsFromRedux === void 0 ? void 0 : metaDataForAllTransactionsFromRedux.appliedFilters) === null || _a === void 0 ? void 0 : _a.fromDate, toDate: (_b = metaDataForAllTransactionsFromRedux === null || metaDataForAllTransactionsFromRedux === void 0 ? void 0 : metaDataForAllTransactionsFromRedux.appliedFilters) === null || _b === void 0 ? void 0 : _b.toDate, searchText: (_c = metaDataForAllTransactionsFromRedux === null || metaDataForAllTransactionsFromRedux === void 0 ? void 0 : metaDataForAllTransactionsFromRedux.appliedFilters) === null || _c === void 0 ? void 0 : _c.searchText }));
    };
    var handleCancelApplyingAllTransactionsFilter = function (isShowPopup) {
        if (isShowPopup === void 0) { isShowPopup = false; }
        setIsShowFilterPopup(isShowPopup);
        handleUpdateAllTransactionsFilter(metaDataForAllTransactionsFromRedux === null || metaDataForAllTransactionsFromRedux === void 0 ? void 0 : metaDataForAllTransactionsFromRedux.appliedFilters);
    };
    var handleApplySIP_STP_SWP_TransactionsFilters = function () {
        di.mutualFundOrderBook.updateSIP_STP_SWP_Filters(SIP_STP_SWP_TransactionsFilter);
        handleCreateFilterLabelsForSIP_SWP_STP_TransactionsTab();
        setIsShowFilterPopup(false);
        getSIP_STP_SWPData(SIP_STP_SWP_TransactionsFilter);
    };
    var handleClearSIP_STP_SWP_Filter = function () {
        var _a, _b, _c;
        di.mutualFundOrderBook.clearSIP_STP_SWP_Filters();
        handleUpdateSIP_STP_SWP_FilterLabels([]);
        setIsShowFilterPopup(false);
        getSIP_STP_SWPData(__assign(__assign({}, JSON.parse(JSON.stringify(SIP_STP_SWP_InitialData.appliedFilters))), { fromDate: (_a = metaDataForSIP_STP_SWP_TransactionsFromRedux === null || metaDataForSIP_STP_SWP_TransactionsFromRedux === void 0 ? void 0 : metaDataForSIP_STP_SWP_TransactionsFromRedux.appliedFilters) === null || _a === void 0 ? void 0 : _a.fromDate, toDate: (_b = metaDataForSIP_STP_SWP_TransactionsFromRedux === null || metaDataForSIP_STP_SWP_TransactionsFromRedux === void 0 ? void 0 : metaDataForSIP_STP_SWP_TransactionsFromRedux.appliedFilters) === null || _b === void 0 ? void 0 : _b.toDate, searchText: (_c = metaDataForSIP_STP_SWP_TransactionsFromRedux === null || metaDataForSIP_STP_SWP_TransactionsFromRedux === void 0 ? void 0 : metaDataForSIP_STP_SWP_TransactionsFromRedux.appliedFilters) === null || _c === void 0 ? void 0 : _c.searchText }));
    };
    var handleCancelApplyingSIP_STP_SWP_Filter = function (isShowPopup) {
        if (isShowPopup === void 0) { isShowPopup = false; }
        setIsShowFilterPopup(isShowPopup);
        handleUpdateSIP_STP_SWP_Filter(JSON.parse(JSON.stringify(metaDataForSIP_STP_SWP_TransactionsFromRedux === null || metaDataForSIP_STP_SWP_TransactionsFromRedux === void 0 ? void 0 : metaDataForSIP_STP_SWP_TransactionsFromRedux.appliedFilters)));
    };
    var handleRemoveAllTransactionsFiltersThroughLabels = function (value, keyName) {
        var updatedLabels = allTransactionsFilterLabels.filter(function (item) { return item.value !== value; });
        var updatedFilters = __assign({}, allTransactionsFilter);
        if (Array.isArray(updatedFilters[keyName])) {
            if (value === "All") {
                updatedFilters[keyName] = [];
            }
            else {
                updatedFilters[keyName] = updatedFilters[keyName].filter(function (item) { return item !== value; });
            }
        }
        handleUpdateAllTransactionsFilterLabels(updatedLabels);
        di.mutualFundOrderBook.updateAllTransactionsFilters(updatedFilters);
        // handleUpdateAllTransactionsFilter(updatedFilters);
        getAllTransactionsData(updatedFilters);
    };
    var handleRemoveSIP_STP_SWP_FiltersThroughLabels = function (value, keyName, subKeyName, filterData) {
        if (filterData === void 0) { filterData = SIP_STP_SWP_TransactionsFilter; }
        var updatedLabels = SIP_STP_SWP_FilterLabels.filter(function (item) { return item.value !== value; });
        var updatedFilters = __assign({}, filterData);
        if (Array.isArray(updatedFilters[keyName])) {
            if (value === "All") {
                updatedFilters[keyName] = [];
            }
            else {
                updatedFilters[keyName] = updatedFilters[keyName].filter(function (item) { return item !== value; });
            }
        }
        di.mutualFundOrderBook.updateSIP_STP_SWP_Filters(updatedFilters);
        handleUpdateSIP_STP_SWP_FilterLabels(updatedLabels);
        // handleUpdateSIP_STP_SWP_Filter(updatedFilters);
        getSIP_STP_SWPData(__assign({}, updatedFilters));
    };
    var handleApplySearchForAllTransactions = function (searchString) {
        var localData = __assign({}, allTransactionsFilter);
        localData.searchText = searchString;
        di.mutualFundOrderBook.updateAllTransactionsFilters(localData);
        debounce(function () {
            return getAllTransactionsData(__assign({}, localData));
        }, 300)();
    };
    var handleApplySearchForSIP_STP_SWP_Transactions = function (searchString) {
        var localData = __assign({}, SIP_STP_SWP_TransactionsFilter);
        localData.searchText = searchString;
        di.mutualFundOrderBook.updateSIP_STP_SWP_Filters(localData);
        debounce(function () {
            return getSIP_STP_SWPData(__assign({}, localData));
        }, 300)();
    };
    var handleDownloadExcel = function () { return __awaiter(void 0, void 0, void 0, function () {
        var payload, isDownloadSuccessful, _a, _b, err_8;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setExcelDownloadLoader(true);
                    payload = undefined;
                    switch (currentSelectedTransactionsTab) {
                        case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                            payload = __assign({}, metaDataForAllTransactionsFromRedux === null || metaDataForAllTransactionsFromRedux === void 0 ? void 0 : metaDataForAllTransactionsFromRedux.appliedFilters);
                            delete payload.txnType;
                            break;
                        case EMutualFundOrderTabs.SIPs:
                        case EMutualFundOrderTabs.STPs:
                        case EMutualFundOrderTabs.SWPs:
                            payload = __assign({}, metaDataForSIP_STP_SWP_TransactionsFromRedux === null || metaDataForSIP_STP_SWP_TransactionsFromRedux === void 0 ? void 0 : metaDataForSIP_STP_SWP_TransactionsFromRedux.appliedFilters);
                            break;
                    }
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 4, , 5]);
                    _b = (_a = di.mutualFundOrderBook).downloadMFOrderBookExcelFile;
                    _c = { loginType: EUserRole.CLIENT };
                    return [4 /*yield*/, accountDetails.getUserLoginCode()];
                case 2: return [4 /*yield*/, _b.apply(_a, [__assign.apply(void 0, [(_c.loginCode = _d.sent(), _c), payload])])];
                case 3:
                    isDownloadSuccessful = _d.sent();
                    // update error messages later
                    if (isDownloadSuccessful) {
                        // setShowToast(true);
                        productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.setToastDetails({
                            isShow: true,
                            isError: false,
                            msg: "Your orders have been successfully exported.",
                        });
                    }
                    else {
                        // setShowToast(true);
                        productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.setToastDetails({
                            isShow: true,
                            isError: true,
                            msg: "Failed to download excel file!",
                        });
                    }
                    setExcelDownloadLoader(false);
                    return [3 /*break*/, 5];
                case 4:
                    err_8 = _d.sent();
                    // update state for technical error once state received from design team
                    setExcelDownloadLoader(false);
                    console.log(err_8);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleSearchClientsInFilters = function (searchedText) {
        var _a, _b;
        setSearchedClient(searchedText);
        var localSearchedClientResult = [];
        switch (currentSelectedTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                localSearchedClientResult = (_a = commonDataFromRedux === null || commonDataFromRedux === void 0 ? void 0 : commonDataFromRedux.allClientsOfRM) === null || _a === void 0 ? void 0 : _a.filter(function (item) {
                    return item.clientName.toLowerCase().includes(searchedText.toLowerCase());
                });
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                localSearchedClientResult = (_b = commonDataFromRedux === null || commonDataFromRedux === void 0 ? void 0 : commonDataFromRedux.allClientsOfRM) === null || _b === void 0 ? void 0 : _b.filter(function (item) {
                    return item.clientName.toLowerCase().includes(searchedText.toLowerCase());
                });
                break;
            default:
                break;
        }
        setLocalClientsList(localSearchedClientResult);
    };
    var handleUpdateLocalClientsListRespectiveToTab = function () {
        switch (currentSelectedTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                setLocalClientsList(function () { return commonDataFromRedux === null || commonDataFromRedux === void 0 ? void 0 : commonDataFromRedux.allClientsOfRM; });
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                setLocalClientsList(function () { return commonDataFromRedux === null || commonDataFromRedux === void 0 ? void 0 : commonDataFromRedux.allClientsOfRM; }
                // () => SIP_STP_SWP_TransactionsDataFromRedux?.clientCodeList
                );
                break;
            default:
                setLocalClientsList([]);
                break;
        }
    };
    var handleApplySearchForMandates = function (searchString) {
        // mandateSearchTextRef.current = searchString;
        debounce(function () {
            di.mutualFundOrderBook.updateAndApplyMandateFilters(__assign(__assign({}, mandatesFilters), { searchText: searchString }));
        }, 300)();
    };
    var handleCancelApplyingMandatesFilters = function (isShowPopup) {
        if (isShowPopup === void 0) { isShowPopup = false; }
        setIsShowFilterPopup(isShowPopup);
        setMandatesFilters(mandateDataFromRedux.appliedFilters);
    };
    var handleApplyMandateFilters = function (data) {
        di.mutualFundOrderBook.updateAndApplyMandateFilters({
            searchText: mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.searchText,
            filteredData: __assign({}, data),
        });
        handleCreateMandateFilterLabels(data);
        setIsShowFilterPopup(false);
    };
    var handleCreateMandateFilterLabels = function (data) {
        var localFilterLabels = [];
        if (!data)
            return;
        Object.keys(data).forEach(function (level1Key) {
            var parentFilter = data[level1Key];
            Object.keys(parentFilter).forEach(function (level2Key) {
                var _a;
                if (parentFilter[level2Key].type !== EFilterType.Date &&
                    parentFilter[level2Key].filterValue) {
                    if (parentFilter[level2Key].subListFiltersValues) {
                        Object.keys(parentFilter[level2Key].subListFiltersValues).forEach(function (subFilterKey) {
                            var _a;
                            localFilterLabels.push({
                                title: (React.createElement("div", null, (_a = parentFilter[level2Key]) === null || _a === void 0 ? void 0 :
                                    _a.displayValue,
                                    ":\u00A0",
                                    parentFilter[level2Key].subListFiltersValues[subFilterKey].filterValue)),
                                disable: false,
                                value: parentFilter[level2Key].subListFiltersValues[subFilterKey]
                                    .filterValue,
                                keyName: level1Key,
                                subKeyName: level2Key,
                            });
                        });
                    }
                    else {
                        localFilterLabels.push({
                            title: React.createElement("div", null, (_a = parentFilter[level2Key]) === null || _a === void 0 ? void 0 : _a.displayValue),
                            disable: false,
                            value: parentFilter[level2Key].filterValue,
                            keyName: level1Key,
                            subKeyName: level2Key,
                        });
                    }
                }
            });
        });
        handleUpdateMandateFilterLabels(localFilterLabels);
    };
    var handleRemoveMandateFiltersThroughLabels = function (value, keyName, subKeyName) {
        var localMandatesFilters = __assign({}, mandatesFilters.filteredData);
        var parentFilter = localMandatesFilters[keyName];
        if (parentFilter[subKeyName].subListFiltersValues) {
            delete parentFilter[subKeyName].subListFiltersValues[value];
            if (!Object.keys(parentFilter[subKeyName].subListFiltersValues).length) {
                delete parentFilter[subKeyName];
                if (!Object.keys(localMandatesFilters[keyName]).length) {
                    delete localMandatesFilters[keyName];
                }
            }
        }
        else {
            delete parentFilter[subKeyName];
        }
        var localFilterLabels = mandateFilterLabels.filter(function (item) { return item.value !== value; });
        di.mutualFundOrderBook.updateAndApplyMandateFilters(__assign(__assign({}, mandateDataFromRedux.appliedFilters), { filteredData: __assign({}, localMandatesFilters) }));
        handleUpdateMandateFilterLabels(localFilterLabels);
    };
    var handleClearAllMandateFilters = function () {
        var _a, _b, _c;
        setIsShowFilterPopup(false);
        setMandatesFilters({
            searchText: (_a = mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters) === null || _a === void 0 ? void 0 : _a.searchText,
            filteredData: {
                dpDate: (_c = (_b = mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters) === null || _b === void 0 ? void 0 : _b.filteredData) === null || _c === void 0 ? void 0 : _c.dpDate,
            },
        });
        setMandateFilterLabels([]);
        di.mutualFundOrderBook.clearMandateFilters();
    };
    var handleOpenTOC = function () {
        var clientDetailsToSidebar = {
            pan: "",
            clientCode: "",
            clientName: "",
            uniqueClientId: "",
            clientTier: "",
        };
        if (currentSelectedTransactionsTab !== EMutualFundOrderTabs.MANDATES) {
            clientDetailsToSidebar = {
                pan: selectedRowDetailsViewDetails.pan,
                clientCode: selectedRowDetailsViewDetails.clientCode,
                clientName: selectedRowDetailsViewDetails.clientName,
                uniqueClientId: selectedRowDetailsViewDetails.ucc,
                clientTier: selectedRowDetailsViewDetails.clientTier,
            };
            setSchemeGroupCodeOfScheme(selectedRowDetailsViewDetails.groupCode);
            setSelectedRowSchemeDetails(selectedRowDetailsViewDetails.scheme);
            setVendorId(selectedRowDetailsViewDetails.vendorTrxId);
            switch (selectedRowDetailsViewDetails.trxType) {
                case EKebebMenuItems.REDEEM:
                    setTransactionTypeOfScheme(EInvestmentType.REDEEM);
                    break;
            }
        }
        if (currentSelectedTransactionsTab === EMutualFundOrderTabs.MANDATES &&
            !isEmpty(selectedRowDetailsViewDetailsForMandates)) {
            clientDetailsToSidebar = {
                pan: selectedRowDetailsViewDetailsForMandates.pan,
                clientCode: selectedRowDetailsViewDetailsForMandates.accCode,
                clientName: selectedRowDetailsViewDetailsForMandates.clientName,
                uniqueClientId: selectedRowDetailsViewDetailsForMandates.uccCode,
                clientTier: selectedRowDetailsViewDetailsForMandates.clientTier,
            };
        }
        setClientDetailsToSidebar(clientDetailsToSidebar);
        setOpenSBViewDetails(false);
        setMfToc(true);
    };
    var handleAll_SIP_STP_SWPTableRowThreeDotsClick = function (transactionId) {
        return function (e) { return __awaiter(void 0, void 0, void 0, function () {
            var rowOfOpenedPopup, updatedKebabMenuItems;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        e.stopPropagation();
                        e.preventDefault();
                        setIsLoadingKebabMenuFlags(true);
                        rowOfOpenedPopup = currentSelectedTransactionsTab === EMutualFundOrderTabs.ALL_TRANSACTIONS
                            ? (_a = allTransactionsDataFromRedux === null || allTransactionsDataFromRedux === void 0 ? void 0 : allTransactionsDataFromRedux.order) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.trxId === transactionId; })
                            : (_b = SIP_STP_SWP_TransactionsDataFromRedux === null || SIP_STP_SWP_TransactionsDataFromRedux === void 0 ? void 0 : SIP_STP_SWP_TransactionsDataFromRedux.order) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.trxId === transactionId; });
                        return [4 /*yield*/, getKebabMenuItemsAsPerCTAFlags(rowOfOpenedPopup)];
                    case 1:
                        updatedKebabMenuItems = _c.sent();
                        if ((rowOfOpenedPopup === null || rowOfOpenedPopup === void 0 ? void 0 : rowOfOpenedPopup.dataSource) === "OPTIMUM") {
                            updatedKebabMenuItems = [AllKebabMenuItems.VIEW_DETAILS];
                        }
                        setTableRowThreeDotActionPopupList(updatedKebabMenuItems);
                        if (updatedKebabMenuItems.length) {
                            setTableRowActionPopupConfig({
                                isShowPopup: true,
                                containerId: transactionId,
                            });
                        }
                        return [2 /*return*/];
                }
            });
        }); };
    };
    var handleMandateTableThreeDotClick = function (rowMandateId, mandateType, dpStatus) {
        return function (e) {
            e.stopPropagation();
            var getMandateType = EDescriptiveMandateType[mandateType];
            var generatedKebabMenuItemsForMandate = generateKebabMenuItemsForMandate(currentSelectedTransactionsTab, getMandateType, dpStatus);
            setTableRowThreeDotActionPopupList(generatedKebabMenuItemsForMandate);
            if (generatedKebabMenuItemsForMandate.length) {
                setMandateId(rowMandateId);
                setTableRowActionPopupConfig({
                    isShowPopup: true,
                    containerId: rowMandateId,
                });
            }
        };
    };
    var handleAllTransactionsAndSIP_STP_SWP_ThreeDotsMenuItemClick = function (item, transactionId) {
        if (transactionId === void 0) { transactionId = trxId; }
        var selectedRowData = currentSelectedTransactionsTab === EMutualFundOrderTabs.ALL_TRANSACTIONS
            ? allTransactionsDataFromRedux === null || allTransactionsDataFromRedux === void 0 ? void 0 : allTransactionsDataFromRedux.order.find(function (item) { return item.trxId === transactionId; })
            : SIP_STP_SWP_TransactionsDataFromRedux === null || SIP_STP_SWP_TransactionsDataFromRedux === void 0 ? void 0 : SIP_STP_SWP_TransactionsDataFromRedux.order.find(function (item) { return item.trxId === transactionId; });
        switch (item) {
            case EKebebMenuItems.PAUSE:
                setMfToc(true);
                setTransactionTypeOfScheme(EInvestmentType.PAUSE);
                break;
            case EKebebMenuItems.RESUME:
                setMfToc(true);
                setTransactionTypeOfScheme(EInvestmentType.RESUME);
                break;
            case EKebebMenuItems.MODIFY:
                setMfToc(true);
                setIsModify(true);
                var updatedTrxType = selectedRowData.trxType;
                if (updatedTrxType === ETransactionType.REDEEM) {
                    updatedTrxType = EInvestmentType.REDEEM;
                }
                setTransactionTypeOfScheme(updatedTrxType);
                break;
            case EKebebMenuItems.CANCEL:
            case EKebebMenuItems.CANCEL_SIP:
                setMfToc(true);
                setTransactionTypeOfScheme(EInvestmentType.CANCEL);
                break;
            case EKebebMenuItems.SWITCH_FUND:
                setMfToc(true);
                setTransactionTypeOfScheme(EInvestmentType.SWITCH);
                break;
            case EKebebMenuItems.START_STP:
                setMfToc(true);
                setTransactionTypeOfScheme(EInvestmentType.STP);
                break;
            case EKebebMenuItems.START_SWP:
                setMfToc(true);
                setTransactionTypeOfScheme(EInvestmentType.SWP);
                break;
            case EKebebMenuItems.VIEW_DETAILS:
            case EKebebMenuItems.VIEW_TRANSACTION:
                setSelectedRowDetailsViewDetails(selectedRowData);
                setOpenSBViewDetails(true);
                break;
            case EKebebMenuItems.RESEND_CONSENT_REQUEST:
                resendConsentRequest(transactionId, selectedRowData === null || selectedRowData === void 0 ? void 0 : selectedRowData.invActionCode);
                // resendConsentRequest(selectedKebabMenuItemTrxId);
                break;
            case EKebebMenuItems.RESEND_PAYMENT_LINK:
                resendPaymentLinkRequest(transactionId, selectedRowData === null || selectedRowData === void 0 ? void 0 : selectedRowData.invActionCode);
                break;
            case EKebebMenuItems.REDEEM:
                setMfToc(true);
                setTransactionTypeOfScheme(EInvestmentType.REDEEM);
                break;
            case EKebebMenuItems.DUPLICATE:
                if (selectedRowData.trxType === ETransactionType.SIP ||
                    selectedRowData.trxType === ETransactionType.LUMPSUM) {
                    handleNavigationToPlaceOrderTable(selectedRowData);
                }
                else {
                    setMfToc(true);
                    setTransactionTypeOfScheme(trxTypeToInvTypeMapping[selectedRowData.trxType]);
                }
                break;
            case EKebebMenuItems.VIEW_ALL_SIPS:
                handleSet_SIP_STP_SWP_tabData(EMutualFundOrderTabs.SIPs);
                di.mutualFundOrderBook.updateCurrentSelectedTransactionTab(EMutualFundOrderTabs.SIPs);
                break;
            case EKebebMenuItems.VIEW_ALL_STPS:
                handleSet_SIP_STP_SWP_tabData(EMutualFundOrderTabs.STPs);
                di.mutualFundOrderBook.updateCurrentSelectedTransactionTab(EMutualFundOrderTabs.STPs);
                break;
            case EKebebMenuItems.VIEW_ALL_SWPS:
                handleSet_SIP_STP_SWP_tabData(EMutualFundOrderTabs.SWPs);
                di.mutualFundOrderBook.updateCurrentSelectedTransactionTab(EMutualFundOrderTabs.SWPs);
                break;
            case EKebebMenuItems.PLACE_ORDER_AGAIN:
                if (selectedRowData.trxType === ETransactionType.REDEEM) {
                    setMfToc(true);
                    setTransactionTypeOfScheme(EInvestmentType.REDEEM);
                }
                else {
                    handleNavigationToPlaceOrderTable(selectedRowData);
                }
                break;
            case EKebebMenuItems.START_SIP:
                handleNavigationToPlaceOrderTable(selectedRowData, ETransactionType.SIP);
                break;
            case EKebebMenuItems.START_LUMPSUM:
                handleNavigationToPlaceOrderTable(selectedRowData, ETransactionType.LUMPSUM);
                break;
            case EKebebMenuItems.EXPLORE_OTHER_FUNDS:
                navigate("/dashboard/product-bouquet?productCode=56&categoryCode=261");
                break;
            default:
        }
        setTableRowActionPopupConfig({
            isShowPopup: false,
            containerId: "",
        });
    };
    var handleSet_SIP_STP_SWP_tabData = function (item) {
        di.mutualFundOrderBook.resetSIP_STP_SWP_TransactionsFiltersAndSearch();
        di.mutualFundOrderBook.resetAllTransactionsFiltersAndSearch();
        (mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.filteredData) &&
            di.mutualFundOrderBook.resetMandateFiltersAndSearch();
        var localSIP_STP_SWP_filter = __assign({}, SIP_STP_SWP_InitialData.appliedFilters);
        localSIP_STP_SWP_filter.txnType = transactionTypeCodeMap[item];
        SIP_STP_SWP_FilterLabels.length && handleUpdateSIP_STP_SWP_FilterLabels([]);
        allTransactionsFilterLabels.length &&
            handleUpdateAllTransactionsFilterLabels([]);
        handleUpdateSIP_STP_SWP_Filter(__assign({}, localSIP_STP_SWP_filter));
        di.mutualFundOrderBook.updateSIP_STP_SWP_Filters(localSIP_STP_SWP_filter);
        getSIP_STP_SWPData(localSIP_STP_SWP_filter);
        (mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.filteredData) &&
            di.mutualFundOrderBook.resetMandateFiltersAndSearch();
    };
    var handleMandateThreeDotMenuItemClick = function (item) {
        if (item === EKebebMenuItems.VIEW_MANDATE_CALENDAR) {
            triggerGetCalendarData(firstDateOfMonth);
            setShowMandateCalendar(true);
        }
        else {
            setViewDetailsForMandateConfig({
                isViewDetailsClicked: true,
                mandateId: mandateId,
            });
        }
        setTableRowActionPopupConfig({
            isShowPopup: false,
            containerId: "",
        });
    };
    var handleTrasnferInThreeDotMenuItemClick = function (item, e) {
        e.stopPropagation();
        e.preventDefault();
        setOpenSBViewDetails(true);
    };
    var handleAssignHandlerForThreeDotMenuItemClick = function (text) { return function (e) {
        e.stopPropagation();
        switch (currentSelectedTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                handleAllTransactionsAndSIP_STP_SWP_ThreeDotsMenuItemClick(text);
                break;
            case EMutualFundOrderTabs.MANDATES:
                handleMandateThreeDotMenuItemClick(text);
            case EMutualFundOrderTabs.TRANSFER_IN:
                handleTrasnferInThreeDotMenuItemClick(text, e);
                break;
        }
    }; };
    var handleTableRowThreeDotsPopupClose = function () {
        setTableRowActionPopupConfig({
            isShowPopup: false,
            containerId: "",
        });
    };
    var handleNavigationToPlaceOrderTable = function (selectedOrderDetails, defaultInvestmentType) {
        var selected_client = getSelectedClientData(selectedOrderDetails);
        var transactionTypes = new Set([
            ETransactionType.SIP,
            ETransactionType.SIP_CANCEL,
            ETransactionType.SIP_INSTALLMENT,
        ]);
        var orderType = selectedOrderDetails.displayTransactionType;
        if (defaultInvestmentType) {
            orderType = defaultInvestmentType;
        }
        else if (transactionTypes.has(selectedOrderDetails.displayTransactionType)) {
            orderType = ETransactionType.SIP;
        }
        navigate("/dashboard/place-order", {
            state: {
                duplicateOrder: __assign(__assign({}, selectedOrderDetails), { dpFlag: selected_client === null || selected_client === void 0 ? void 0 : selected_client.dpFlag, direct_plan_enabled_flg: selected_client === null || selected_client === void 0 ? void 0 : selected_client.direct_plan_enabled_flg }),
                defaultInvestmentType: orderType,
                categoryCode: ESubProductIds.MutualFund,
            },
        });
    };
    var handleMandateCalendarFilterChange = function (data) {
        var localMandateFilterData = __assign({}, mandatesFilters);
        localMandateFilterData.filteredData.dpDate = {
            fromDate: __assign(__assign({}, localMandateFilterData.filteredData.dpDate.fromDate), { filterValue: data.fromDate }),
            toDate: __assign(__assign({}, localMandateFilterData.filteredData.dpDate.toDate), { filterValue: data.toDate }),
        };
        handleUpdateMandateFiltersData(localMandateFilterData);
        handleApplyMandateFilters(localMandateFilterData.filteredData);
    };
    var handleApplyCalendarFilterForAllTransactions = function (data) {
        di.mutualFundOrderBook.updateAllTransactionsFilters(data);
        getAllTransactionsData(data);
    };
    var handleApplyCalendarFilterForSIP_STP_SWPTransactions = function (data) {
        di.mutualFundOrderBook.updateSIP_STP_SWP_Filters(data);
        getSIP_STP_SWPData(data);
    };
    var handleApplyTransferInCalendarFilters = function (data) {
        var _a, _b;
        getOrderbookTransferInTableData({
            fromdate: (_a = data === null || data === void 0 ? void 0 : data.fromDate) !== null && _a !== void 0 ? _a : "",
            todate: (_b = data === null || data === void 0 ? void 0 : data.toDate) !== null && _b !== void 0 ? _b : "",
        });
    };
    var handleSelectAllOrderStatus = function (areAllSelected) {
        var _a, _b;
        switch (currentSelectedTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                {
                    var updatedFilters = __assign({}, allTransactionsFilter);
                    updatedFilters.status = [];
                    if (!areAllSelected) {
                        updatedFilters.status =
                            (_a = handleChooseDataFromReduxForOperation()) === null || _a === void 0 ? void 0 : _a.tranSummaryList.map(function (item) { return item.status; });
                    }
                    handleUpdateAllTransactionsFilter(updatedFilters);
                }
                break;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                {
                    var updatedFilters = __assign({}, SIP_STP_SWP_TransactionsFilter);
                    updatedFilters.status = [];
                    if (!areAllSelected) {
                        updatedFilters.status =
                            (_b = handleChooseDataFromReduxForOperation()) === null || _b === void 0 ? void 0 : _b.tranSummaryList.map(function (item) { return item.status; });
                    }
                    setSIP_STP_SWP_TransactionsFilter(updatedFilters);
                }
                break;
        }
    };
    var handleSelectAllTransactionsInvestmentTypeFilters = function (areAllSelected) {
        var updatedFilters = __assign({}, allTransactionsFilter);
        updatedFilters.investType = [];
        if (!areAllSelected) {
            updatedFilters.investType = investmentTypeFilter === null || investmentTypeFilter === void 0 ? void 0 : investmentTypeFilter.map(function (item) { return item.value; });
        }
        handleUpdateAllTransactionsFilter(updatedFilters);
    };
    var handleChooseDataFromReduxForOperation = function () {
        switch (currentSelectedTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                return allTransactionsDataFromRedux;
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                return SIP_STP_SWP_TransactionsDataFromRedux;
        }
    };
    var handleOrderbookSBClose = function (value) {
        setViewDetailsForMandateConfig({
            isViewDetailsClicked: false,
            mandateId: "",
        });
        setOpenSBViewDetails(value);
    };
    var handleCreateFilterLabelsForAllTransactionsTab = function (localAllTransactionsFilterData) {
        var _a, _b, _c, _d, _e;
        if (localAllTransactionsFilterData === void 0) { localAllTransactionsFilterData = allTransactionsFilter; }
        var localFilterLabels = [];
        if (localAllTransactionsFilterData === null || localAllTransactionsFilterData === void 0 ? void 0 : localAllTransactionsFilterData.clientCodes) {
            var selectedClients = (_a = commonDataFromRedux.allClientsOfRM) === null || _a === void 0 ? void 0 : _a.filter(function (item) {
                var _a;
                return (_a = localAllTransactionsFilterData === null || localAllTransactionsFilterData === void 0 ? void 0 : localAllTransactionsFilterData.clientCodes) === null || _a === void 0 ? void 0 : _a.includes(item.accountCode);
            });
            selectedClients === null || selectedClients === void 0 ? void 0 : selectedClients.forEach(function (client) {
                localFilterLabels.push({
                    title: (React.createElement(ClientNamesWithHorizontalClientCodes, { clientCode: client === null || client === void 0 ? void 0 : client.accountCode, clientName: client === null || client === void 0 ? void 0 : client.clientName, clientType: "Client" })),
                    disable: false,
                    value: client === null || client === void 0 ? void 0 : client.accountCode,
                    keyName: "clientCodes",
                    subKeyName: client === null || client === void 0 ? void 0 : client.clientName,
                });
            });
        }
        if (localAllTransactionsFilterData === null || localAllTransactionsFilterData === void 0 ? void 0 : localAllTransactionsFilterData.status) {
            var selectedStatuses = (_b = allTransactionsDataFromRedux === null || allTransactionsDataFromRedux === void 0 ? void 0 : allTransactionsDataFromRedux.tranSummaryList) === null || _b === void 0 ? void 0 : _b.filter(function (item) { var _a; return (_a = localAllTransactionsFilterData === null || localAllTransactionsFilterData === void 0 ? void 0 : localAllTransactionsFilterData.status) === null || _a === void 0 ? void 0 : _a.includes(item.status); });
            if (((_c = allTransactionsDataFromRedux === null || allTransactionsDataFromRedux === void 0 ? void 0 : allTransactionsDataFromRedux.tranSummaryList) === null || _c === void 0 ? void 0 : _c.length) ===
                ((_d = localAllTransactionsFilterData === null || localAllTransactionsFilterData === void 0 ? void 0 : localAllTransactionsFilterData.status) === null || _d === void 0 ? void 0 : _d.length)) {
                localFilterLabels.push({
                    title: (React.createElement("div", { className: "d-flex align-items-center gap-10" }, "Order Status: All")),
                    disable: false,
                    value: "All",
                    keyName: "status",
                    subKeyName: "All",
                });
            }
            else {
                selectedStatuses === null || selectedStatuses === void 0 ? void 0 : selectedStatuses.forEach(function (status) {
                    localFilterLabels.push({
                        title: (React.createElement("div", { className: "d-flex align-items-center gap-10" },
                            "Order Status: ", status === null || status === void 0 ? void 0 :
                            status.status)),
                        disable: false,
                        value: status === null || status === void 0 ? void 0 : status.status,
                        keyName: "status",
                        subKeyName: status === null || status === void 0 ? void 0 : status.status,
                    });
                });
            }
        }
        if (localAllTransactionsFilterData === null || localAllTransactionsFilterData === void 0 ? void 0 : localAllTransactionsFilterData.investType) {
            if ((investmentTypeFilter === null || investmentTypeFilter === void 0 ? void 0 : investmentTypeFilter.length) ===
                ((_e = localAllTransactionsFilterData === null || localAllTransactionsFilterData === void 0 ? void 0 : localAllTransactionsFilterData.investType) === null || _e === void 0 ? void 0 : _e.length)) {
                localFilterLabels.push({
                    title: (React.createElement("div", { className: "d-flex align-items-center gap-10" }, "Investment Type: All")),
                    disable: false,
                    value: "All",
                    keyName: "investType",
                    subKeyName: "All",
                });
            }
            else {
                var selectedInvestmentType = investmentTypeFilter === null || investmentTypeFilter === void 0 ? void 0 : investmentTypeFilter.filter(function (item) { var _a; return (_a = localAllTransactionsFilterData === null || localAllTransactionsFilterData === void 0 ? void 0 : localAllTransactionsFilterData.investType) === null || _a === void 0 ? void 0 : _a.includes(item.value); });
                selectedInvestmentType === null || selectedInvestmentType === void 0 ? void 0 : selectedInvestmentType.forEach(function (investmentType) {
                    localFilterLabels.push({
                        title: (React.createElement("div", { className: "d-flex align-items-center gap-10" },
                            "Investment Type: ", investmentType === null || investmentType === void 0 ? void 0 :
                            investmentType.label)),
                        disable: false,
                        value: investmentType === null || investmentType === void 0 ? void 0 : investmentType.value,
                        keyName: "investType",
                        subKeyName: investmentType === null || investmentType === void 0 ? void 0 : investmentType.value,
                    });
                });
            }
        }
        handleUpdateAllTransactionsFilterLabels(localFilterLabels);
    };
    var handleCreateFilterLabelsForSIP_SWP_STP_TransactionsTab = function (localSIP_SWP_STP_FiltersData) {
        var _a, _b, _c, _d;
        if (localSIP_SWP_STP_FiltersData === void 0) { localSIP_SWP_STP_FiltersData = SIP_STP_SWP_TransactionsFilter; }
        var localFilterLabels = [];
        if (localSIP_SWP_STP_FiltersData === null || localSIP_SWP_STP_FiltersData === void 0 ? void 0 : localSIP_SWP_STP_FiltersData.status) {
            if (((_a = SIP_STP_SWP_TransactionsDataFromRedux === null || SIP_STP_SWP_TransactionsDataFromRedux === void 0 ? void 0 : SIP_STP_SWP_TransactionsDataFromRedux.tranSummaryList) === null || _a === void 0 ? void 0 : _a.length) ===
                ((_b = localSIP_SWP_STP_FiltersData === null || localSIP_SWP_STP_FiltersData === void 0 ? void 0 : localSIP_SWP_STP_FiltersData.status) === null || _b === void 0 ? void 0 : _b.length)) {
                localFilterLabels.push({
                    title: (React.createElement("div", { className: "d-flex align-items-center gap-10" }, "Order Status: All")),
                    disable: false,
                    value: "All",
                    keyName: "status",
                    subKeyName: "All",
                });
            }
            else {
                var selectedStatuses = (_c = SIP_STP_SWP_TransactionsDataFromRedux === null || SIP_STP_SWP_TransactionsDataFromRedux === void 0 ? void 0 : SIP_STP_SWP_TransactionsDataFromRedux.tranSummaryList) === null || _c === void 0 ? void 0 : _c.filter(function (item) { var _a; return (_a = localSIP_SWP_STP_FiltersData === null || localSIP_SWP_STP_FiltersData === void 0 ? void 0 : localSIP_SWP_STP_FiltersData.status) === null || _a === void 0 ? void 0 : _a.includes(item.status); });
                selectedStatuses === null || selectedStatuses === void 0 ? void 0 : selectedStatuses.forEach(function (status) {
                    localFilterLabels.push({
                        title: (React.createElement("div", { className: "d-flex align-items-center gap-10" },
                            "Order Status: ", status === null || status === void 0 ? void 0 :
                            status.status)),
                        disable: false,
                        value: status === null || status === void 0 ? void 0 : status.status,
                        keyName: "status",
                        subKeyName: status === null || status === void 0 ? void 0 : status.status,
                    });
                });
            }
        }
        if (localSIP_SWP_STP_FiltersData === null || localSIP_SWP_STP_FiltersData === void 0 ? void 0 : localSIP_SWP_STP_FiltersData.clientCodes) {
            var selectedClients = (_d = commonDataFromRedux === null || commonDataFromRedux === void 0 ? void 0 : commonDataFromRedux.allClientsOfRM) === null || _d === void 0 ? void 0 : _d.filter(function (item) { var _a; return (_a = localSIP_SWP_STP_FiltersData === null || localSIP_SWP_STP_FiltersData === void 0 ? void 0 : localSIP_SWP_STP_FiltersData.clientCodes) === null || _a === void 0 ? void 0 : _a.includes(item.accountCode); });
            selectedClients === null || selectedClients === void 0 ? void 0 : selectedClients.forEach(function (client) {
                localFilterLabels.push({
                    title: (React.createElement(ClientNamesWithHorizontalClientCodes, { clientCode: client === null || client === void 0 ? void 0 : client.accountCode, clientName: client === null || client === void 0 ? void 0 : client.clientName, clientType: "Client" })),
                    disable: false,
                    value: client === null || client === void 0 ? void 0 : client.accountCode,
                    keyName: "clientCodes",
                    subKeyName: client === null || client === void 0 ? void 0 : client.clientName,
                });
            });
        }
        handleUpdateSIP_STP_SWP_FilterLabels(localFilterLabels);
    };
    var handleMandateFilterChange = function (data) {
        handleUpdateMandateFiltersData(__assign(__assign({}, mandatesFilters), { filteredData: __assign({}, data) }));
    };
    var handleSetTocFromTocHoc = function (value, restArgs) {
        var localRestArgs = !!restArgs && (restArgs === null || restArgs === void 0 ? void 0 : restArgs.length) && typeof restArgs[0] === "object"
            ? restArgs[0]
            : {};
        if (localRestArgs && "transactionsTab" in localRestArgs) {
            handleTabChange(localRestArgs === null || localRestArgs === void 0 ? void 0 : localRestArgs.transactionsTab);
        }
        else if (localRestArgs === null || localRestArgs === void 0 ? void 0 : localRestArgs.callAPIAndCleanFilters) {
            handleTabChange(currentSelectedTransactionsTab);
        }
        setMfToc(false);
        // setIsInOfScheme("");
        // setIsInOfSchemeName("");
        // setSchemeCodeOfScheme("");
        setSelectedRowSchemeDetails(null);
        setTrxId("");
        setSchemeGroupCodeOfScheme("");
        setIsModify(false);
        setClientDetailsToSidebar(null);
    };
    var handleApplySearchForTransferIn = function (searchString) {
        debounce(function () {
            return getOrderbookTransferInTableData({
                searchValue: searchString,
            });
        }, 400)();
    };
    // *******************************************
    // *           MISCELLANEOUS Functions       *
    // *******************************************
    var getSelectedClientData = function (selectedRowData) {
        var _a;
        var selectedClient = (_a = commonDataFromRedux.allClientsOfRM) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.accountCode === selectedRowData.clientCode; });
        return Boolean(selectedClient) ? selectedClient : undefined;
    };
    // *******************************************
    // *           Constants                     *
    // *******************************************
    var allTransactionsFilterTabs = [
        {
            eventKey: "investmentType",
            title: "Investment Type",
            tabContent: generateInvestmentTypeFilter(),
        },
        {
            title: "Order Status",
            eventKey: "orderStatus",
            tabContent: generateFiltersLoaderOrErrorUI(metaDataForAllTransactionsFromRedux.mutualFundAllTransactionsTableShimmer, allTransactionsDataFromRedux === null || allTransactionsDataFromRedux === void 0 ? void 0 : allTransactionsDataFromRedux.tranSummaryList, function () { return generateAllTransactionsOrderStatusFilters(); }),
        },
        {
            title: "Client Name",
            eventKey: "clientName",
            tabContent: generateFiltersLoaderOrErrorUI(commonDataFromRedux === null || commonDataFromRedux === void 0 ? void 0 : commonDataFromRedux.allClientLoader, commonDataFromRedux === null || commonDataFromRedux === void 0 ? void 0 : commonDataFromRedux.allClientsOfRM, function () { return generateAllTransactionsClientNamesFilters(); }),
        },
    ];
    var commonSIP_STP_SWP_TransactionsFilterTabs = [
        {
            title: "Order Status",
            eventKey: "orderStatus",
            tabContent: generateFiltersLoaderOrErrorUI(metaDataForSIP_STP_SWP_TransactionsFromRedux.mutualFundSIP_STP_SWP_TransactionsTableShimmer, SIP_STP_SWP_TransactionsDataFromRedux === null || SIP_STP_SWP_TransactionsDataFromRedux === void 0 ? void 0 : SIP_STP_SWP_TransactionsDataFromRedux.tranSummaryList, function () { return generateSIP_STP_SWP_TransactionsOrderStatusFilters(); }),
        },
        {
            title: "Client Name",
            eventKey: "clientName",
            tabContent: generateFiltersLoaderOrErrorUI(commonDataFromRedux === null || commonDataFromRedux === void 0 ? void 0 : commonDataFromRedux.allClientLoader, commonDataFromRedux === null || commonDataFromRedux === void 0 ? void 0 : commonDataFromRedux.allClientsOfRM, function () { return generateSIP_STP_SWP_TransactionsClientNamesFilters(); }),
        },
    ];
    var SIP_TransactionsFilterTabs = __spreadArray([], __read(commonSIP_STP_SWP_TransactionsFilterTabs), false);
    var STP_TransactionsFilterTabs = __spreadArray([], __read(commonSIP_STP_SWP_TransactionsFilterTabs), false);
    var SWP_TransactionsFilterTabs = __spreadArray([], __read(commonSIP_STP_SWP_TransactionsFilterTabs), false);
    var mandateTransactionsFiltersTabs = [
        {
            title: "Order Status",
            eventKey: "orderStatus",
            tabContent: (React.createElement(MandateOrderStatusFilters, { handleFilterChangeCallback: handleMandateFilterChange, selectedFiltersData: mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData })),
        },
        {
            title: "Mandate Type",
            eventKey: "mandateType",
            tabContent: (React.createElement(MandateTypeFilters, { handleFilterChangeCallback: handleMandateFilterChange, selectedFiltersData: mandatesFilters === null || mandatesFilters === void 0 ? void 0 : mandatesFilters.filteredData })),
        },
    ];
    var mutualFundOrderTabs = useMemo(function () {
        return transactionType === null || transactionType === void 0 ? void 0 : transactionType.map(function (item) {
            var _a;
            switch (item.transactionType) {
                case EMutualFundOrderTabs.ALL_TRANSACTIONS: {
                    return {
                        title: EMutualFundOrderTabs.ALL_TRANSACTIONS,
                        eventKey: EMutualFundOrderTabs.ALL_TRANSACTIONS,
                        tabContent: (React.createElement(AllTransactions, { tableColumns: generateAllTransactionsTableColumns(), showViewAll: !(productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.detailedViewEnabled), viewAllOnClick: function () {
                                return productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.viewAllClickCallback(EProductIds.MANAGED_PORTFOLIO, ESubProductIds.MutualFund);
                            }, tableData: allTransactionsDataFromRedux === null || allTransactionsDataFromRedux === void 0 ? void 0 : allTransactionsDataFromRedux.order, showShimmer: metaDataForAllTransactionsFromRedux.mutualFundAllTransactionsTableShimmer, defaultSortingColumnKey: "displayCreatedTime", openSB: openSBViewDetails, setOpenSB: handleOrderbookSBClose, selectedRowDetails: selectedRowDetailsViewDetails, setSelectedRowDetails: setSelectedRowDetailsViewDetails, getSelectedClientData: getSelectedClientData, setOpenTOC: handleOpenTOC })),
                    };
                }
                case EMutualFundOrderTabs.SIPs: {
                    return {
                        title: EMutualFundOrderTabs.SIPs,
                        eventKey: EMutualFundOrderTabs.SIPs,
                        tabContent: (React.createElement(React.Fragment, null,
                            React.createElement(SIPOrders, { tableColumns: generateSIPOrderTableColumns(), tableData: SIP_STP_SWP_TransactionsDataFromRedux === null || SIP_STP_SWP_TransactionsDataFromRedux === void 0 ? void 0 : SIP_STP_SWP_TransactionsDataFromRedux.order, showViewAll: !(productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.detailedViewEnabled), viewAllOnClick: function () {
                                    return productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.viewAllClickCallback(EProductIds.MANAGED_PORTFOLIO, ESubProductIds.MutualFund);
                                }, showShimmer: metaDataForSIP_STP_SWP_TransactionsFromRedux.mutualFundSIP_STP_SWP_TransactionsTableShimmer, defaultSortingColumnKey: "displayCreatedTime", selectedDefaultSortType: "Date", openSB: openSBViewDetails, setOpenSB: handleOrderbookSBClose, selectedRowDetails: selectedRowDetailsViewDetails, setSelectedRowDetails: setSelectedRowDetailsViewDetails, getSelectedClientData: getSelectedClientData, setOpenTOC: handleOpenTOC }))),
                    };
                }
                case EMutualFundOrderTabs.STPs: {
                    return {
                        title: EMutualFundOrderTabs.STPs,
                        eventKey: EMutualFundOrderTabs.STPs,
                        tabContent: (React.createElement(STPOrders, { tableColumns: generateSTPOrderTableColumns(), tableData: SIP_STP_SWP_TransactionsDataFromRedux === null || SIP_STP_SWP_TransactionsDataFromRedux === void 0 ? void 0 : SIP_STP_SWP_TransactionsDataFromRedux.order, showViewAll: !(productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.detailedViewEnabled), viewAllOnClick: function () {
                                return productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.viewAllClickCallback(EProductIds.MANAGED_PORTFOLIO, ESubProductIds.MutualFund);
                            }, showShimmer: metaDataForSIP_STP_SWP_TransactionsFromRedux.mutualFundSIP_STP_SWP_TransactionsTableShimmer, defaultSortingColumnKey: "displayCreatedTime", openSB: openSBViewDetails, setOpenSB: handleOrderbookSBClose, selectedRowDetails: selectedRowDetailsViewDetails, setSelectedRowDetails: setSelectedRowDetailsViewDetails, getSelectedClientData: getSelectedClientData, setOpenTOC: handleOpenTOC })),
                    };
                }
                case EMutualFundOrderTabs.SWPs: {
                    return {
                        title: EMutualFundOrderTabs.SWPs,
                        eventKey: EMutualFundOrderTabs.SWPs,
                        tabContent: (React.createElement(SWPOrders, { tableColumns: generateSWPOrderTableColumns(), tableData: SIP_STP_SWP_TransactionsDataFromRedux === null || SIP_STP_SWP_TransactionsDataFromRedux === void 0 ? void 0 : SIP_STP_SWP_TransactionsDataFromRedux.order, showViewAll: !(productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.detailedViewEnabled), viewAllOnClick: function () {
                                return productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.viewAllClickCallback(EProductIds.MANAGED_PORTFOLIO, ESubProductIds.MutualFund);
                            }, showShimmer: metaDataForSIP_STP_SWP_TransactionsFromRedux.mutualFundSIP_STP_SWP_TransactionsTableShimmer, defaultSortingColumnKey: "displayCreatedTime", openSB: openSBViewDetails, setOpenSB: handleOrderbookSBClose, selectedRowDetails: selectedRowDetailsViewDetails, setSelectedRowDetails: setSelectedRowDetailsViewDetails, getSelectedClientData: getSelectedClientData, setOpenTOC: handleOpenTOC })),
                    };
                }
                case EMutualFundOrderTabs.MANDATES: {
                    return {
                        title: EMutualFundOrderTabs.MANDATES,
                        eventKey: EMutualFundOrderTabs.MANDATES,
                        tabContent: (React.createElement(MandateOrders, { tableColumns: generateMandatesOrderTableColumns(), tableData: (_a = mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.filteredData) === null || _a === void 0 ? void 0 : _a.lst, showViewAll: !(productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.detailedViewEnabled), viewAllOnClick: function () {
                                return productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.viewAllClickCallback(EProductIds.MANAGED_PORTFOLIO, ESubProductIds.MutualFund);
                            }, showShimmer: isShowMandatesShimmer, defaultSortingColumnKey: "dpDate", openSB: openSBViewDetails, setOpenSB: handleOrderbookSBClose, selectedRowDetails: {}, setSelectedRowDetails: setSelectedRowDetailsViewDetailsForMandates, handleOpenTOC: handleOpenTOC, mandateIdForViewDetails: {
                                isViewDetailsClicked: viewDetailsForMandateConfig === null || viewDetailsForMandateConfig === void 0 ? void 0 : viewDetailsForMandateConfig.isViewDetailsClicked,
                                mandateId: viewDetailsForMandateConfig === null || viewDetailsForMandateConfig === void 0 ? void 0 : viewDetailsForMandateConfig.mandateId,
                            } })),
                    };
                }
                case EMutualFundOrderTabs.TRANSFER_IN:
                    return {
                        title: EMutualFundOrderTabs.TRANSFER_IN,
                        eventKey: EMutualFundOrderTabs.TRANSFER_IN,
                        tabContent: (React.createElement(OrderbookTransferInTable, { tableColumns: generateTransferInTableColumns(), showViewAll: !(productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.detailedViewEnabled), viewAllOnClick: function () {
                                productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.viewAllClickCallback(EProductIds.MANAGED_PORTFOLIO, ESubProductIds.MutualFund);
                                getOrderbookTransferInTableData({ fromdate: "2015-04-01" });
                            }, tableData: transferInDataFromRedux === null || transferInDataFromRedux === void 0 ? void 0 : transferInDataFromRedux.transferInData, showShimmer: transferInDataFromRedux === null || transferInDataFromRedux === void 0 ? void 0 : transferInDataFromRedux.mutualFundTransferInTableShimmer, openSB: openSBViewDetails, setOpenSB: handleOrderbookSBClose, selectedRowDetails: selectedViewDetailsTransferIn, setSelectedRowDetails: setSelectedViewDetailsTransferIn, callbackSorted: function (e) {
                                setSortType(function () { return ({
                                    type: e.type
                                        ? ESortOrder.ASCENDING
                                        : ESortOrder.DESCENDING,
                                    sortKey: e.sortKey,
                                }); });
                                getOrderbookTransferInTableData({
                                    orderbydesc: e.type ? false : true,
                                    orderby: e.sortKey,
                                });
                            }, selectedSortVal: sortType.type, defaultSortingColumnKey: sortType.sortKey })),
                    };
            }
        });
    }, [
        transactionType,
        metaDataForAllTransactionsFromRedux.mutualFundAllTransactionsTableShimmer,
        metaDataForSIP_STP_SWP_TransactionsFromRedux === null || metaDataForSIP_STP_SWP_TransactionsFromRedux === void 0 ? void 0 : metaDataForSIP_STP_SWP_TransactionsFromRedux.mutualFundSIP_STP_SWP_TransactionsTableShimmer,
        metaDataForAllTransactionsFromRedux.allTransactionsData,
        metaDataForSIP_STP_SWP_TransactionsFromRedux === null || metaDataForSIP_STP_SWP_TransactionsFromRedux === void 0 ? void 0 : metaDataForSIP_STP_SWP_TransactionsFromRedux.SIP_STP_SWP_TransactionsData,
        mandateDataFromRedux.filteredData,
        isShowMandatesShimmer,
        openSBViewDetails,
        tableRowActionPopupConfig,
        productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.detailedViewEnabled,
        commonDataFromRedux.allClientsOfRM,
        transferInDataFromRedux === null || transferInDataFromRedux === void 0 ? void 0 : transferInDataFromRedux.mutualFundTransferInTableShimmer,
    ]);
    // *******************************************
    // *           UseEffects                    *
    // *******************************************
    useEffect(function () {
        triggerGetTransactionTypeData();
        getAllClientOfRM();
        if (leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderId) {
            getAllTransactionsData(__assign(__assign({}, metaDataForAllTransactionsFromRedux === null || metaDataForAllTransactionsFromRedux === void 0 ? void 0 : metaDataForAllTransactionsFromRedux.appliedFilters), { trxId: leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderId, fromDate: leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderDate, toDate: leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderDate }));
            timeOutIdForUpdateAllTransactionsFilters = setTimeout(function () {
                di.mutualFundOrderBook.updateAllTransactionsFilters(__assign(__assign({}, metaDataForAllTransactionsFromRedux === null || metaDataForAllTransactionsFromRedux === void 0 ? void 0 : metaDataForAllTransactionsFromRedux.appliedFilters), { trxId: leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderId, fromDate: leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderDate, toDate: leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderDate, searchText: leadRedirectionState === null || leadRedirectionState === void 0 ? void 0 : leadRedirectionState.orderId }));
            }, 500);
        }
        else {
            switch (currentSelectedTransactionsTab) {
                case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                    getAllTransactionsData();
                    break;
                case EMutualFundOrderTabs.SIPs:
                case EMutualFundOrderTabs.STPs:
                case EMutualFundOrderTabs.SWPs:
                    getSIP_STP_SWPData();
                    break;
                case EMutualFundOrderTabs.MANDATES:
                    getMandatesData();
                    break;
                case EMutualFundOrderTabs.TRANSFER_IN:
                    getOrderbookTransferInTableData();
                    break;
            }
        }
        return function () {
            if (timeOutIdForUpdateAllTransactionsFilters) {
                clearTimeout(timeOutIdForUpdateAllTransactionsFilters);
            }
        };
    }, []);
    // React.useEffect(() => {
    //   setAllTransactionsData(allTransactionsDataFromRedux?.data);
    // }, [allTransactionsDataFromRedux]);
    React.useEffect(function () {
        // setAllTransactionsData(allTransactionsDataFromRedux?.data);
        setIsShowFilterPopup(false);
    }, [allTransactionsDataFromRedux, currentSelectedTransactionsTab]);
    useEffect(function () {
        // setOrderSummaryData(SIP_STP_SWP_TransactionsDataFromRedux?.data);
        setIsShowFilterPopup(false);
    }, [SIP_STP_SWP_TransactionsDataFromRedux, currentSelectedTransactionsTab]);
    useEffect(function () {
        if (currentSelectedTransactionsTab === EMutualFundOrderTabs.ALL_TRANSACTIONS) {
            handleUpdateAllTransactionsFilter(JSON.parse(JSON.stringify(metaDataForAllTransactionsFromRedux === null || metaDataForAllTransactionsFromRedux === void 0 ? void 0 : metaDataForAllTransactionsFromRedux.appliedFilters)));
            handleCreateFilterLabelsForAllTransactionsTab(JSON.parse(JSON.stringify(metaDataForAllTransactionsFromRedux === null || metaDataForAllTransactionsFromRedux === void 0 ? void 0 : metaDataForAllTransactionsFromRedux.appliedFilters)));
        }
    }, [
        metaDataForAllTransactionsFromRedux === null || metaDataForAllTransactionsFromRedux === void 0 ? void 0 : metaDataForAllTransactionsFromRedux.appliedFilters,
        currentSelectedTransactionsTab,
    ]);
    useEffect(function () {
        if (currentSelectedTransactionsTab !== EMutualFundOrderTabs.ALL_TRANSACTIONS) {
            handleUpdateSIP_STP_SWP_Filter(JSON.parse(JSON.stringify(metaDataForSIP_STP_SWP_TransactionsFromRedux === null || metaDataForSIP_STP_SWP_TransactionsFromRedux === void 0 ? void 0 : metaDataForSIP_STP_SWP_TransactionsFromRedux.appliedFilters)));
            handleCreateFilterLabelsForSIP_SWP_STP_TransactionsTab(JSON.parse(JSON.stringify(metaDataForSIP_STP_SWP_TransactionsFromRedux === null || metaDataForSIP_STP_SWP_TransactionsFromRedux === void 0 ? void 0 : metaDataForSIP_STP_SWP_TransactionsFromRedux.appliedFilters)));
        }
    }, [
        metaDataForSIP_STP_SWP_TransactionsFromRedux === null || metaDataForSIP_STP_SWP_TransactionsFromRedux === void 0 ? void 0 : metaDataForSIP_STP_SWP_TransactionsFromRedux.appliedFilters,
        currentSelectedTransactionsTab,
    ]);
    useEffect(function () {
        var _a;
        if (currentSelectedTransactionsTab === EMutualFundOrderTabs.MANDATES &&
            (mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters)) {
            handleUpdateMandateFiltersData(JSON.parse(JSON.stringify(mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters)));
            handleCreateMandateFilterLabels((_a = mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters) === null || _a === void 0 ? void 0 : _a.filteredData);
        }
    }, [mandateDataFromRedux === null || mandateDataFromRedux === void 0 ? void 0 : mandateDataFromRedux.appliedFilters, currentSelectedTransactionsTab]);
    useEffect(function () {
        handleUpdateLocalClientsListRespectiveToTab();
    }, [
        // activeTabKey,
        currentSelectedTransactionsTab,
        allTransactionsDataFromRedux === null || allTransactionsDataFromRedux === void 0 ? void 0 : allTransactionsDataFromRedux.clientCodeList,
        SIP_STP_SWP_TransactionsDataFromRedux === null || SIP_STP_SWP_TransactionsDataFromRedux === void 0 ? void 0 : SIP_STP_SWP_TransactionsDataFromRedux.clientCodeList,
    ]);
    useEffect(function () {
        if (isShowFilterPopup) {
            handleUpdateLocalClientsListRespectiveToTab();
        }
        setSearchedClient("");
    }, [isShowFilterPopup]);
    var orderDetailsForSelectedRow = useMemo(function () {
        if (!trxId)
            return;
        switch (currentSelectedTransactionsTab) {
            case EMutualFundOrderTabs.ALL_TRANSACTIONS:
                return allTransactionsDataFromRedux === null || allTransactionsDataFromRedux === void 0 ? void 0 : allTransactionsDataFromRedux.order.find(function (x) { return x.trxId === trxId; });
            case EMutualFundOrderTabs.SIPs:
            case EMutualFundOrderTabs.STPs:
            case EMutualFundOrderTabs.SWPs:
                return SIP_STP_SWP_TransactionsDataFromRedux === null || SIP_STP_SWP_TransactionsDataFromRedux === void 0 ? void 0 : SIP_STP_SWP_TransactionsDataFromRedux.order.find(function (x) { return x.trxId === trxId; });
        }
    }, [currentSelectedTransactionsTab, trxId]);
    return (React.createElement(MutualFundOrderbookContext.Provider, { value: {
            getCTADetailsAsPerFlags: getKebabMenuItemsAsPerCTAFlags,
            handleOnClickOfAvailableCTAs: handleAllTransactionsAndSIP_STP_SWP_ThreeDotsMenuItemClick,
        } },
        React.createElement("div", { className: "primary-mutual-fund-order-container d-flex flex-column ".concat((_b = props.parentClassName) !== null && _b !== void 0 ? _b : "", " ").concat(!(productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.detailedViewEnabled) ? "gap-3" : "gap-1"), ref: orderbookRef },
            React.createElement("div", { className: "d-flex gap-3 align-items-center ".concat(!(productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.detailedViewEnabled) ? "" : "mgt-30") },
                React.createElement("div", { className: "txt_midnight-blue-shade2 ".concat(!(productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.detailedViewEnabled)
                        ? "DMSansNormal_20_400"
                        : "DMSansBold_25_700 mb-20") }, "Mutual Funds")),
            (productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.detailedViewEnabled) ? (React.createElement("div", { className: "search-panel-container" }, generateSearchAndFilterPanel(generatePropsForSearchPanel()))) : null,
            React.createElement(GenericTabs, { defaultActiveKey: currentSelectedTransactionsTab, tabsArray: mutualFundOrderTabs, callBackFunction: handleTabChange, externalClassName: "d-flex flex-column mutual-fund-order-tabs w-100 ".concat(!(productOrdersContext === null || productOrdersContext === void 0 ? void 0 : productOrdersContext.detailedViewEnabled)
                    ? "gap-20"
                    : "custom-gap-for-search") })),
        showMandateCalendar && (React.createElement("div", { className: "d-flex justify-content-between align-items-center w-100" },
            React.createElement(MandateCalendar, { isMandateCalendarShow: showMandateCalendar, dateAmountDict: dateAmountDict, triggerGetCalendarData: triggerGetCalendarData, setShowMandateCalendar: setShowMandateCalendar }))),
        mfToc && (React.createElement(TocHoc, { component: MutualFund, clientDetails: clientDetailsToSidebar, isin: selectedRowSchemeDetails === null || selectedRowSchemeDetails === void 0 ? void 0 : selectedRowSchemeDetails.isin, isinName: selectedRowSchemeDetails === null || selectedRowSchemeDetails === void 0 ? void 0 : selectedRowSchemeDetails.isinName, schemeCode: selectedRowSchemeDetails === null || selectedRowSchemeDetails === void 0 ? void 0 : selectedRowSchemeDetails.grpCode, schemeplan: selectedRowSchemeDetails === null || selectedRowSchemeDetails === void 0 ? void 0 : selectedRowSchemeDetails.schPlan, schemeGroupCode: schemeGroupCodeOfScheme, onlyEQACC: true, isModify: isModify, mfmodifyData: orderDetailsForSelectedRow, dontCloseOnOutsideClick: true, setShowTOC: handleSetTocFromTocHoc, outsideClick: function () {
                setMfToc(false);
                // setIsInOfScheme("");
                // setIsInOfSchemeName("");
                // setSchemeCodeOfScheme("");
                setSelectedRowSchemeDetails(null);
                setTrxId("");
                setSchemeGroupCodeOfScheme("");
                setIsModify(false);
                setClientDetailsToSidebar(null);
            }, showToc: mfToc, investmentType: transactionTypeOfScheme, isTriggeredFromOrderBook: currentSelectedTransactionsTab === EMutualFundOrderTabs.MANDATES &&
                (selectedRowDetailsViewDetailsForMandates === null || selectedRowDetailsViewDetailsForMandates === void 0 ? void 0 : selectedRowDetailsViewDetailsForMandates.dpStatus) ===
                    EMandateStatuses.REGISTRATION_FAILED, blurBackground: true })),
        tableRowActionPopupConfig.isShowPopup &&
            (tableRowThreeDotActionPopupList === null || tableRowThreeDotActionPopupList === void 0 ? void 0 : tableRowThreeDotActionPopupList.length) > 0 && (React.createElement(Overlay, { show: tableRowActionPopupConfig.isShowPopup, target: document.getElementById(tableRowActionPopupConfig.containerId), rootClose: true, rootCloseEvent: "mousedown", onHide: function () { return handleTableRowThreeDotsPopupClose(); }, placement: "bottom-end", container: document.getElementById(tableRowActionPopupConfig.containerId) },
            React.createElement(Popover, { id: "popover-contained", className: "table-actions-without-generic-popup-container removePopupTooltipArrow", style: { position: "fixed" } },
                React.createElement(Popover.Body, null,
                    React.createElement("div", { className: "table-actions-internal-list-wrapper flex-column flexCenter" }, isLoadingKebabMenuFlags ? (React.createElement("div", { className: "action-internal-item displayFlex align-self-start gap-10" },
                        React.createElement(Spinner, { animation: "border", variant: "primary", className: "txt_tomatoRed" }))) : (React.createElement(React.Fragment, null, tableRowThreeDotActionPopupList === null || tableRowThreeDotActionPopupList === void 0 ? void 0 : tableRowThreeDotActionPopupList.map(function (item, index) {
                        return (React.createElement("div", { className: "action-internal-item displayFlex align-self-start gap-10 hand_cursor", key: index, tabIndex: 0, onClick: handleAssignHandlerForThreeDotMenuItemClick(item.text) },
                            React.createElement("i", { className: item.icon }),
                            React.createElement("label", { className: "DMSanN_14_400 txt-han-blue hand_cursor" }, item.text)));
                    }))))))))));
};
export default MutualFundOrders;
